import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CellEditingStoppedEvent, ColDef, FilterChangedEvent, GridOptions, GridPreDestroyedEvent, GridReadyEvent, IRichCellEditorParams, ISelectCellEditorParams, MenuItemDef, PasteEndEvent, StatusPanelDef } from 'ag-grid-community';
import { ConfirmationService } from 'primeng/api';
import { CropCodingType } from 'src/app/models/cropCodingType';
import { Crop } from 'src/app/models/crop';
import { GridPreference } from 'src/app/models/gridPreference';
import { InbredCodingArg, TraitValue } from 'src/app/models/inbredCodingArg';
import { CropMaterialTypeGender } from 'src/app/models/cropMaterialTypeGender';
import { Settings } from 'src/app/models/settings';
import { TICodeTemplateDTO, TICodeTemplateStartingMaterial } from 'src/app/models/tiCodeTemplateDTO';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { CustomMessageService } from 'src/app/services/custom.message.service';
import { ResetService } from 'src/app/services/reset.service';
import { SettingService } from 'src/app/services/setting.service';
import { CustomStatusBarComponent } from 'src/app/shared/custom-status-bar';
import { InventorLeEditorComponent } from 'src/app/shared/inventorLeEditorComponent';
import { StaticFields } from 'src/app/shared/staticFields';
import { HttpParams } from '@angular/common/http';
import { LoadingService } from 'src/app/services/loading.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-code',
  templateUrl: './code.component.html',
  styleUrl: './code.component.scss'
})
export class CodeComponent implements OnInit {
  @ViewChild('codeGridFilterBar') codeGridFilterBar!: CustomStatusBarComponent;
  selectedCrop : any;
  selHistoryCrop: any;
  disableCrop : boolean = true;
  collapseSearch: boolean = false;
  collapseResults: boolean = true;
  collapseHistory: boolean = true;
  //inventorHeaderNames: string[] = [];
  assessmentMembersList: any[]= [];
  assessmentMembers: any[] = [];
  searchType: string = "Get All Assessments";
  searchBy: string = "GE ID";
  selectType: string = "Show all Assessments";
  showSelected: boolean = false
  selectedMembers: any;
  enableSearch: boolean = false;
  rowData: any[] =[];
  idList: string[] = [];
  inventorsList : any[] = [];
  codingCrops:string[] = ['CORN', 'CANO', 'MILL', 'RICE', 'SORG', 'SUN', 'WHE', 'SOY', 'COTN'];
  tandemCrops: string[] = ['CANO', 'MILL', 'RICE', 'SORG', 'SUN', 'WHE'];
  cropCodingTypeList: CropCodingType [] = [
    { Crop: "CORN", CodingTypes: [{CodingType: "Heterotic", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "ForwardBred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] },
    { Crop: "CANO", CodingTypes: [{CodingType: "Heterotic", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "ForwardBred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] },
    { Crop: "MILL", CodingTypes: [{CodingType: "Heterotic", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "ForwardBred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] },
    { Crop: "RICE", CodingTypes: [{CodingType: "Heterotic", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "ForwardBred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] },
    { Crop: "SORG", CodingTypes: [{CodingType: "Heterotic", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "ForwardBred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] },
    { Crop: "SUN", CodingTypes: [{CodingType: "Heterotic", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "ForwardBred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] },
    { Crop: "WHE", CodingTypes: [{CodingType: "Heterotic", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "ForwardBred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] },
    { Crop: "SOY", CodingTypes: [{CodingType: "Fixed Line", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "Purification / Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] },
    { Crop: "COTN", CodingTypes: [{CodingType: "Fixed Line", IsRequiredTrait: true, IsOptionalTrait: false}, {CodingType: "FixedLine ForwardBred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Purification", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Purification Forward Bred", IsRequiredTrait: true, IsOptionalTrait: true}, {CodingType: "Conversion", IsRequiredTrait: true, IsOptionalTrait: true}] }
  ];
  codingMap: any = {
    'Heterotic': 'HETR',
    'ForwardBred': 'FORW',
    'Fixed Line': 'FIXEDLINE',
    'Conversion': 'CONV',
    'Purification / Conversion': 'PURIFICATION',
    'Purification Forward Bred': 'FORW',
    'Purification': 'PURIFICATION',
    'FixedLine ForwardBred': 'FIXEDLINEFORW'
  };
  cropMaterialTypeGenders: CropMaterialTypeGender [] = [
    { Crop: "CORN", MaterialTypeGenders: [ {MaterialType: "INB"}] },  
    { Crop: "CANO", MaterialTypeGenders: [ {MaterialType: "ALIN", Genders: ["A"]}, {MaterialType: "BLIN", Genders: ["B"]}, {MaterialType: "RLIN", Genders: ["R"]}]},
    { Crop: "MILL", MaterialTypeGenders: [ {MaterialType: "ALIN", Genders: ["A"]}, {MaterialType: "BLIN", Genders: ["B"]}, {MaterialType: "RLIN", Genders: ["R"]}]},
    { Crop: "RICE", MaterialTypeGenders: [ {MaterialType: "ALIN", Genders: ["A"]}, {MaterialType: "BLIN", Genders: ["B"]}, {MaterialType: "INB", Genders: ["N"]}, {MaterialType: "RLIN", Genders: ["R"]}] },
    { Crop: "SORG", MaterialTypeGenders: [ {MaterialType: "ALIN", Genders: ["A"]}, {MaterialType: "BLIN", Genders: ["B"]}, {MaterialType: "RLIN", Genders: ["N","R"]}] },
    { Crop: "SUN", MaterialTypeGenders: [ {MaterialType: "ALIN", Genders: ["A"]}, {MaterialType: "BLIN", Genders: ["B"]}, {MaterialType: "RLIN", Genders: ["N","R"]}] },
    { Crop: "WHE", MaterialTypeGenders: [ {MaterialType: "ALIN", Genders: ["A"]}, {MaterialType: "BLIN", Genders: ["B"]}, {MaterialType: "RLIN", Genders: ["R"]}]},
    { Crop: "SOY", MaterialTypeGenders: [ {MaterialType: "EXPV"} ]},
    { Crop: "COTN", MaterialTypeGenders: [ {MaterialType: "EXPV"}] }
  ];
  selectedCodeType: string;
  public defaultColDef: ColDef = {
    sortable: true,
    filter: 'agSetColumnFilter',
    filterParams: { buttons: ["clear"] },
    minWidth : 50, 
    resizable: true,
    width : 165,
    headerClass: (params: any) => { 
      return params.column.colId === 'error' ? 'errorHeader': null;
    }
  };
  allowEdit: boolean = true;
  public columnDefs: ColDef[] = [];
  public statusBar: {
    statusPanels: StatusPanelDef[];
  } = {
    statusPanels: [
      { statusPanel: 'agTotalRowCountComponent', align: 'left' },
      { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left',  },
      { statusPanel: 'agFilteredRowCountComponent', align : 'left' },
      { statusPanel: 'agSelectedRowCountComponent', align : 'left' },
    ],
  };
  gridOptions : GridOptions = {
    context: {
      componentParent: this,
    },
    tooltipShowDelay: 100,
    sideBar: { toolPanels: [{
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivotMode: true,
      },
    },
    'filters'] },
    onGridPreDestroyed: this.onGridPreDestroyed
  }
  histColDefs: ColDef[] = [
    { field: 'fileName', headerName: 'File Name' },
    { field: 'status', headerName: 'Status', cellRenderer: this.setStatus.bind(this) },
    { field: 'count', headerName: 'GEs Submitted', cellRenderer: this.setDataCount.bind(this) },
    { field: 'tiCount', headerName: 'TI Count', hide: true, cellRenderer: this.setTIDataCount.bind(this) },
    { field: 'submitTI', headerName: 'Submit TI', hide: true, cellRenderer: this.resubmitTI.bind(this) },
    { field: 'crop', headerName: 'Crop' },
    { field: 'codingType', headerName: 'Coding Type' },
    { field: 'actionOn', headerName: 'Submitted On', cellRenderer: (params: any) => { 
      return params.data.actionOn ? new Date ((new Date(params.data.actionOn)) + " UTC").toLocaleString() : new Date().toLocaleString()
    } },
    { field: 'user', headerName: 'Submitted By' },
    { field: 'successExcelLink', headerName: 'Coded File', cellRenderer: (params: any) => { 
      return params.data.successExcelLink ? `<a href="${params.data.successExcelLink.replace('https://pcm-prod', 'https://pcm').replace('https://precodemanager', 'https://pcm').replace('.corteva.com', '.vylor.com')}" target="_blank">Download</a>` : ''
    } },
    { field: 'failedExcelLink', headerName: 'Failed File', cellRenderer: (params: any) => { 
      return params.data.failedExcelLink ? `<a href="${params.data.failedExcelLink.replace('https://pcm-prod', 'https://pcm').replace('https://precodemanager', 'https://pcm').replace('.corteva.com', '.vylor.com')}" target="_blank">Download</a>` : ''
    } }
  ];
  showSearch: boolean = false;
  searchHeight: number;
  sideBarHeight: string;
  invalidIds: string[] = [];
  gridApi: any;
  histGridApi: any;
  tiGridApi: any;
  selectedType: string;
  userGridPreference: GridPreference = new GridPreference();
  navigatedExternal: boolean = false;
  programs: any[];
  selectedProgram: any;
  years: any[] = StaticFields.years;
  selectedYear: any;
  validValues: any;
  showTemplateModal: boolean;
  selCodeType: any;
  templateType: string;
  fileName: string;
  showLoader: boolean = false;
  maxDate: Date = new Date();
  beginDate: Date = new Date(this.maxDate.getFullYear(), this.maxDate.getMonth(), this.maxDate.getDate() - 30);
  endDate: Date;
  historyData: any = [];
  showCodingData: boolean = false;
  codingData: any = [];
  codingColDefs: ColDef[] = [];
  selHistoryRow: any;
  allCodingUsers: any[] = [];
  selUser: any;
  gridDefOptions : GridOptions = {
    context: {
      componentParent: this,
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
    },
    tooltipShowDelay: 100,
    sideBar: { toolPanels: [{
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivotMode: true,
      },
    },
    'filters'] }
  }
  styleRequired: any =  {"border": "1px solid red"};
  showPanelSearch: boolean = true;
  viewTIData: boolean = false;
  showTIData: boolean = false;
  tiData: any = [];
  tiPrograms: any[];
  tiProgram: any;
  tiYear: any;
  tiColDefs: ColDef[] = [];  

  constructor(@Inject(SettingService) private config: Settings, public loader: LoadingService, private apiService : ApiService, public commonService : CommonService,  public customMessageService: CustomMessageService, 
    private confirmationService : ConfirmationService, private router : ActivatedRoute, private resetService: ResetService, public msalService: MsalService) {
    this.selectedType = 'Show all Assessments';
     this.resetService.resetData$.subscribe(responseService => {
      if (responseService) {    
        if (ResetService.Programs == responseService){
          this.setPrograms(null);
        }
      }
    });
  }

  get idListText(): string {
    return this.idList.join("\r\n");
  }

  get codingTypes(): string [] {
    return this.selectedCrop ? this.cropCodingTypeList.filter(p => p.Crop == this.selectedCrop.Name).flatMap(p => p.CodingTypes.map(p => p.CodingType)) : [];
  }

  get excelCodingTypes(): string [] {
    return this.selectedCrop ? this.cropCodingTypeList.filter(p => p.Crop == this.selectedCrop.Name).flatMap(p => p.CodingTypes.map(p => p.CodingType)) : [];
  }

  get disableSubmit(): boolean {
    // if(StaticFields.userInfo?.onPremisesSamAccountName == "ggk845") {
    //    return false;
    // }
    if (this.rowData.length === 0 || (this.config.environment.toUpperCase() !== 'PROD' && StaticFields.isNSLProd)) {
      return true;
    }
    return false;    
  }

  get disableTISubmit(): boolean {
    if (this.tiData.filter((d: any) => d.sendToTI == true).length === 0 || (this.config.environment.toUpperCase() !== 'PROD' && StaticFields.isNSLProd)) {
      return true;
    }
    return false;    
  }

  get disableTIValidate(): boolean {
    if (this.tiData.filter((d: any) => d.sendToTI == true).length === 0) {
      return true;
    }
    return false;    
  }

  get disableRetrieve(): boolean {
    if (this.selectedCrop?.Name === 'CORN')
      return !(this.idListText.length > 0 && this.selectedProgram && this.selectedYear)
    return !(this.idListText.length > 0 && this.selectedCrop)
  }

  set idListText(value) {
    this.idList = value.split(/\r?\n/);
    if (this.idList.length < 2)
      this.idList = value.split(",");
    this.idList = this.idList.filter((v, i, a) => a.indexOf(v) === i);
    this.idList = this.idList.map(s => s.trim()).filter(s => s);
  }

  get crops(): Crop [] {
    return StaticFields?.crops && StaticFields?.crops?.length > 0 ? StaticFields?.crops?.filter(ele => this.codingCrops.includes(ele.Name)) : [];
  }

  get showResubmitTI(): boolean {
    return this.selHistoryRow && this.selHistoryRow.status.includes("TI Failed") ? true : false;
  }

  get invalidIdListText(): string {
    return this.invalidIds.join("\r\n");
  }

  get codingUsersByCrop(): any {
    if (this.selHistoryCrop && this.allCodingUsers.length > 0)
      return this.allCodingUsers.filter(u => u.crop === this.selHistoryCrop.Name);
    return null;
  }

  ngOnInit(): void {
    if (StaticFields.userClaim.isPCMSuperUser || StaticFields.userClaim.isPCMAdmin) {
      this.apiService.getData("GetAllCodingUsers", null, false).subscribe((users: any) => {
        if (users && users.length > 0) {
          users.forEach((u: any) => {
            this.allCodingUsers.push({id: u.appUserId, name: u.fileName, crop: u.crop});
          });
        }
      });
    }
    this.setSearchHeight();
    if (StaticFields.appUserId)
      this.setScreenData();  
    else {
      const interval = setInterval(() => {
        if (StaticFields.appUserId) {
          this.setScreenData();
          clearInterval(interval);
        }
      }, 2000);
    }
    const elements = document.getElementsByClassName("footer-container");
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = 'none';
    }
  }

  setSearchHeight() {
    this.searchHeight = window.innerHeight - 175;
    this.sideBarHeight = `${this.searchHeight + 10}px`;      
  }

  setScreenData() {   
    this.router.queryParamMap.subscribe((p : any) => {
      if (p['params'] && p['params']['selectedGes']) {
        this.navigatedExternal = true;
        this.selectedCrop = this.crops.find(ele => ele.Name == p['params']['crop']);
        this.setPrograms(p);
      }
    })
    if (!this.navigatedExternal) {
      if (StaticFields.codingPageData) {
        this.selectedCrop = this.crops.find(ele => ele.Name == StaticFields.codingPageData.crop.name);
        this.searchBy = StaticFields.codingPageData['cvn'].length > 0 ? "CVN" : "GE ID"
        this.idList = StaticFields.codingPageData['cvn'].length > 0 ? StaticFields.codingPageData['cvn'] : StaticFields.codingPageData['geIds'];
        this.columnDefs = StaticFields.codingPageData.columnDefs;
        this.rowData = StaticFields.codingPageData.data;
        this.collapseHistory = this.collapseSearch = true;
        this.collapseResults = false;  
      }
      else if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId) {
        this.selectedCrop = this.crops.find(ele => ele.Name == StaticFields.precodePreference.crop);      
      }
      this.setPrograms(null);
      //this.showPanelSearch = StaticFields.precodePreference && StaticFields.precodePreference.appUserId ? false : true;
    }
  }

  onCodingTypeChanged() {
    if (this.selectedCrop.Name !== 'SOY' && this.gridApi) {
      this.gridApi.setColumnsVisible(['suffix'], this.codingMap[this.selectedCodeType] === "FORW" || this.codingMap[this.selectedCodeType] === "CONV");
      this.gridApi.setColumnsVisible(['convBase'], this.codingMap[this.selectedCodeType] === "CONV");
    }

    let codingType = this.cropCodingTypeList.filter(p => p.Crop == this.selectedCrop.Name).flatMap(p => p.CodingTypes).find(p => p.CodingType == this.selectedCodeType);
    let visibleTraitNames: string[] = [];
    let inVisibleTraitNames: string[] = [];

    if (codingType.IsRequiredTrait && !codingType.IsOptionalTrait) {
      visibleTraitNames = this.validValues.filter((p: any) => p.isRequiredTrait).map((p: any) => p.traitName.toLowerCase());
      inVisibleTraitNames = this.validValues.filter((p: any) => !p.isRequiredTrait).map((p: any) => p.traitName.toLowerCase());
    }
    else if (!codingType.IsRequiredTrait && codingType.IsOptionalTrait) {
      visibleTraitNames = this.validValues.filter((p: any) => !p.isRequiredTrait).map((p: any) => p.traitName.toLowerCase());
      inVisibleTraitNames = this.validValues.filter((p: any) => p.isRequiredTrait).map((p: any) => p.traitName.toLowerCase());
    }
    else if (!codingType.IsRequiredTrait && !codingType.IsOptionalTrait) {
      inVisibleTraitNames = this.validValues.map((p: any) => p.traitName.toLowerCase());
    }
    else if (codingType.IsRequiredTrait && codingType.IsOptionalTrait) {
      visibleTraitNames = this.validValues.map((p: any) => p.traitName.toLowerCase());    
    }
    if (this.gridApi) {
      visibleTraitNames.forEach(visibleTraitName => this.gridApi.setColumnsVisible([visibleTraitName], true));
      inVisibleTraitNames.forEach(inVisibleTraitName => this.gridApi.setColumnsVisible([inVisibleTraitName], false));
      this.gridApi.redrawRows();
    }
  }

  hideCol(col: string): boolean {
    if (this.selectedCrop.Name !== 'SOY' && col === 'suffix' && (this.codingMap[this.selectedCodeType] === "FORW" || this.codingMap[this.selectedCodeType] === "CONV"))
      return false;
    if (this.selectedCrop.Name !== 'SOY' && col === 'convBase' && this.codingMap[this.selectedCodeType] === "CONV")
      return false;
    return true;
  }

  setPrograms(paramMap: any) {
    if (!this.selectedCrop)
      return;
    this.selHistoryCrop = this.selectedCrop;
    this.selectedProgram = this.selectedYear = null;
    this.selCodeType = this.selectedCodeType = this.codingTypes[0];
    this.idList = [];
    this.getGridPreferences();
    //this.apiService.getRADData(`Programs?$filter=CropId eq ${this.selectedCrop.Id} and Status/Name eq 'Active'&$select=Id,Code,Description`, false).subscribe((result : any) => {
    let selectCountry = '';
    if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
      selectCountry = ',CountryName';
    if (paramMap)
      this.loader.setMessage('Loading...');
    this.apiService.getOData(`ProgramPreferences?$filter=CropName eq '${this.selectedCrop.Name}'and IsActive&$select=Id,Code,Description${selectCountry}`, paramMap ? false : true).subscribe((result : any) => {
      if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
        result.value = result.value.filter((r: any) => StaticFields.countriesToShow.includes(r.countryName.toUpperCase()));
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)); 
      this.tiPrograms = this.programs = result.value.map((d: any) => { return {code: d.code, desc: d.description};});
      if (paramMap) {
        this.selectedProgram = this.programs.find(e => e.code ==  paramMap['params']['selectedProgram']);
        this.selectedYear =  paramMap['params']['selectedYear'];
        const geIds = paramMap['params']['selectedGes'];
        if (geIds) {
          this.idList = geIds;
          this.retrieveData();
        } 
      }
    });
  }
  
  getUserGridPreferences(gridName: string, isSessionSelected: false, showLoader: boolean) {
    // let params = new HttpParams();
    // params = params.append('gridName', gridName);
    // params = params.append('appUserId', StaticFields.appUserId);
    // params = params.append('hasSessionData', isSessionSelected);
    this.apiService.getOData(`UserGridPreferences?$filter=AppUserId eq ${StaticFields.appUserId} and GridName eq '${gridName}'`, showLoader).subscribe((res: any) => {
      if (res.data) {
         this.userGridPreference = res.data ? res.data : new GridPreference();
      }
    });
  }

  resetPreferences() {
    this.confirmationService.confirm({
      header: 'Reset',
      icon: 'pi pi-exclamation-triangle',
      message: `Do you want to reset the search criteria ?`,      
      accept: () => {
        this.selectedCrop = StaticFields.precodePreference?.crop ? this.crops.find(ele => ele.Name === StaticFields.precodePreference.crop) : this.crops[0];
        this.selectedProgram = this.selectedYear = null;
        this.selCodeType = this.selectedCodeType = this.codingTypes[0];
        this.idList = [];
        this.rowData.splice(0);
        this.columnDefs.splice(0);
        this.collapseSearch = false;
        this.collapseHistory = this.collapseResults = true;
        this.selectedCodeType = null;
        StaticFields.codingPageData = null;
        this.invalidIds = [];
        this.setPrograms(null);
      }
    });
    
  }
  fill(params: any, fillType: string) {
    const selRows: any = [];
    if (fillType === "down" || fillType === "up") {
      let idx = params.node.rowIndex;
      params.api.forEachNodeAfterFilterAndSort((rowNode: any) => {
        if ((fillType === "up" ? idx > rowNode.childIndex : idx < rowNode.childIndex) && (params.column.colId === 'parentRole' || params.column.colId === 'comments' || params.column.colId.includes('_SIID') ? rowNode.data.sendToTI : true)) {          
          rowNode.data[params.column.colId] = params.value;
          selRows.push(rowNode);
          if (params.column.colId === 'inventorLeIds') {
            const rowInventors = Object.keys(rowNode.data).filter(col => col.startsWith('Inventor'));
            rowInventors.forEach(c => rowNode.data[c] = '');
            const inventors = Object.keys(params.node.data).filter(col => col.startsWith('Inventor'));
            if (inventors.length > 0) {
              inventors.forEach(c => rowNode.data[c] = params.node.data[c]);
              const foundInventors = this.inventorsList.find((e : any) => e.geId == rowNode.data.geId);
              if (foundInventors)
                foundInventors.inventors = this.inventorsList.find((e : any) => e.geId == params.node.data.geId).inventors;
              else 
                this.inventorsList.push({ geId : rowNode.data.geId, inventors: this.inventorsList.find((e : any) => e.geId == params.node.data.geId).inventors });
            }
            
          }
        }
      });
    } else if (fillType === "selected") {
      params.api.getSelectedRows().forEach((rowNode: any) => {
        if (params.column.colId === 'parentRole' || params.column.colId === 'comments' || params.column.colId.includes('_SIID') ? rowNode.data.sendToTI : true) {
          rowNode.data[params.column.colId] = params.value;
          selRows.push(rowNode);
          if (params.column.colId === 'inventorLeIds') {
            const rowInventors = Object.keys(rowNode.data).filter(col => col.startsWith('Inventor'));
            rowInventors.forEach(c => rowNode.data[c] = '');
            const inventors = Object.keys(params.node.data).filter(col => col.startsWith('Inventor'));
            if (inventors.length > 0) {
              inventors.forEach(c => rowNode.data[c] = params.node.data[c]);
              const foundInventors = this.inventorsList.find((e : any) => e.geId == rowNode.data.geId);
              if (foundInventors)
                foundInventors.inventors = this.inventorsList.find((e : any) => e.geId == params.node.data.geId).inventors;
              else 
                this.inventorsList.push({ geId : rowNode.data.geId, inventors: this.inventorsList.find((e : any) => e.geId == params.node.data.geId).inventors });
            }
          }
        }
      });
    }
    const inventorCols = params.context.componentParent.columnDefs.filter((c: any) => c.field !== 'inventorLeIds' && c.field.startsWith('Inventor'));
    let isUpdateColsRequired = false;
    inventorCols.forEach((c: any) => {
      if (params.context.componentParent.rowData.filter((d: any) => d[c.field]).length === 0) {
        params.context.componentParent.columnDefs.splice(params.context.componentParent.columnDefs.findIndex((col: any) => col.field === c.field), 1);
        isUpdateColsRequired = true;
      }
    });
    if (isUpdateColsRequired)
      params.api.setGridOption("columnDefs", params.context.componentParent.columnDefs);
    //params.api.refreshCells(params);
    this.gridApi.redrawRows({ rowNodes: selRows });
  }

  getContextMenuItems(  params: any ): (string | MenuItemDef)[] {
    const result: (string | MenuItemDef)[] = [
      {
        name: 'Remove Row',
        disabled: !(params.api.getSelectedRows().length > 0),
        action: function () { params.context.componentParent.removeRows(params, "row"); }
      },
      {
        name: 'Remove Selected',
        disabled: !(params.api.getSelectedRows().length > 0),
        action: function () { params.context.componentParent.removeRows(params, "selected"); }
      },
      {
        name: 'Fill Up',
        disabled: params.node.rowIndex === 0 || !params.context.componentParent.columnDefs.find((c: any) => c.field === params.column.colId).editable,
        action: function () { params.context.componentParent.fill(params, "up"); },
      },
      {
        name: 'Fill Down',
        disabled: !(params.node.rowIndex < params.context.componentParent.rowData.length) || !params.context.componentParent.columnDefs.find((c: any) => c.field === params.column.colId).editable,
        action: function () { params.context.componentParent.fill(params, "down"); }
      },
      {
        name: 'Remove Value',
        disabled: !(params.value && params.column.colDef.editable),
        action: function () { params.context.componentParent.removeValue(params); }
      },
      // {
      //   name: 'Fill Selected',
      //   disabled: !(params.value && params.api.getSelectedRows().length > 1),
      //   action: function () { params.context.componentParent.fill(params, "selected"); }
      // },
      'copy',
      'copyWithHeaders',
      'separator',
      'export'
    ]
    return result;
  }

  removeValue(params : any) {
    params.node.data[params.column.colDef.field] = "";
    this.gridApi.redrawRows({ rowNodes: [params.node] });
  }

  removeRows(params: any, type: string) {
    if (type === "row") {
      const index = this.rowData.findIndex((ele : any) => ele.geId == params.node.data.geId);
      this.rowData.splice(index,1);
      this.gridApi!.applyTransaction({ remove: [params.node.data] })!;
    } else {
      const selectedNodes = this.gridApi.getSelectedRows();
      this.gridApi!.applyTransaction({ remove: selectedNodes })!;
      this.rowData = this.rowData.filter((ele : any) => {
        return selectedNodes.indexOf(ele) === -1;
      })
    }
    if (StaticFields.codingPageData)
      StaticFields.codingPageData.data = this.rowData;
  }

  setCodingColumns() {
    let hetrForwCodingType = ["HETR","FORW"];
    this.columnDefs = [
      { headerName: '', field: 'selected', pinned: 'left', checkboxSelection: true, headerCheckboxSelection : true, headerCheckboxSelectionFilteredOnly: true, suppressFiltersToolPanel: true, lockPosition: "left", suppressHeaderFilterButton: true,suppressHeaderMenuButton: true, resizable: false, width:25, suppressColumnsToolPanel: true},
      { field: 'crop', headerName : 'Crop', width : 165,  headerTooltip : 'Crop' },
      //{ field: 'year', headerName : 'Year', width : 165,  headerTooltip : 'Year', filter: 'agNumberColumnFilter' },
      { field: 'geId', headerName : 'GeId*', width : 165, headerTooltip : 'GeId', filter: 'agNumberColumnFilter', cellStyle: (params: any) => {  
        return params.data.geId ? null : this.styleRequired;       
      }},
      { field: 'cvn', headerName : 'Ge Name', width : 165,headerTooltip : 'Ge Name' },  
      { field: 'pedigree', headerName : 'Pedigree', width : 165,headerTooltip : 'Pedigree' },
      { field: 'currentMaterialType', headerName : 'Current MatType', width : 165,headerTooltip : 'Current Material Type' },
      { field: 'inventorLeIds', headerName : 'InventorLeIds*', headerTooltip: 'InventorLeIds',  width : 165, editable: this.allowEdit, cellEditor: InventorLeEditorComponent,
        cellStyle: (params: any) => {  
          return params.data.inventorLeIds ? null : this.styleRequired;       
        }},
      { field: 'program', headerName : 'Program', width : 165, headerTooltip : 'Program' },
      { field: 'stage', headerName : 'PStage', width : 165, headerTooltip: 'PStage' },   
      { field: 'metaData', headerName : 'MetaData', width : 165, headerTooltip : 'Meta Data' },
      { field: 'generation', headerName : 'Gen', headerTooltip: 'Generation' , width : 165 },
      { field: 'convBase', headerName : 'ConvBase', headerTooltip: 'ConvBase',  width : 165, editable: this.allowEdit, hide: this.hideCol('convBase'),
        cellStyle: (params: any) => {  
          return this.codingMap[this.selectedCodeType] == "CONV" && (params.data.convBase == undefined || params.data.convBase == "") ? this.styleRequired : null;       
        }},    
      { field: 'suffix', headerName : 'Suffix', headerTooltip: 'Suffix',  width : 165, editable: this.allowEdit, hide: this.hideCol('suffix'),
        cellStyle: (params: any) => {  
        return this.codingMap[this.selectedCodeType] == "FORW" && (params.data.suffix == undefined || params.data.suffix == "") ? this.styleRequired : null;       
      }},
      { field: 'materialType', headerName : 'Intended MatType*', headerTooltip: 'Intended Material Type',  width : 165, editable: this.allowEdit, cellEditor: "agSelectCellEditor", cellEditorParams: (params : any) => {  return { values: this.cropMaterialTypeGenders.filter(p => p.Crop == params.data.crop).flatMap(p => p.MaterialTypeGenders.map(p => p.MaterialType))}}, 
        cellStyle: (params: any) => {  
        return params.data.materialType ? null : this.styleRequired;       
      }}
    ];
    if (this.selectedCrop.Name === 'CORN') {
      this.columnDefs.push({ field: 'heteroticPrefix', headerName : 'HeteroticPrefix*', headerTooltip: 'HeteroticPrefix',  width : 165, editable: this.allowEdit, 
        cellStyle: (params: any) => {  
           return params.data.crop == "CORN" && hetrForwCodingType.includes(this.codingMap[this.selectedCodeType]) && (params.data.heteroticPrefix == undefined || params.data.heteroticPrefix == "") ? this.styleRequired : null;       
        }});
      this.columnDefs.push({ field: 'sendToTI', headerName : 'Send To TI', cellRenderer: 'agCheckboxCellRenderer', headerTooltip: 'Check to send SIID to TI', width : 165, 
        tooltipValueGetter: (p: any) => {
          if (this.columnDefs.findIndex(col => col.field.includes('~')) > -1)
            return '';
          return 'Disabled, since no Starting Material found for selected project and year';
        },
        editable: (p: any) => {
          if (this.columnDefs.findIndex(col => col.field.includes('~')) > -1 && this.allowEdit)
            return true;
          return false;
        }
      });
      this.columnDefs.push({ field: 'comments', headerName : 'Comments', headerTooltip: 'comments',  width : 165, editable: (params : any) => params.data.sendToTI } );
      this.columnDefs.push({ field: 'parentRole', headerName : 'ParentRole', headerTooltip: 'parentRole',  width : 165, editable: (params : any) => params.data.sendToTI, cellEditor: "agSelectCellEditor", cellEditorParams: { values: ["Male", "Female"] } as ISelectCellEditorParams,
        cellStyle: (params: any) => {  
          return params.data.sendToTI && (params.data.parentRole == undefined || params.data.parentRole == "") ? this.styleRequired : null;       
        }});   
    }
    if (this.tandemCrops.includes(this.selectedCrop.Name)) {
      this.columnDefs.push({ field: 'gender', headerName : 'Gender', headerTooltip: 'gender',  width : 165, editable: this.allowEdit, cellEditor: "agSelectCellEditor",
        cellStyle: (params: any) => {  
          return params.data.gender ? null: this.styleRequired;       
       }, cellEditorParams: (params : any) => { return { values: this.cropMaterialTypeGenders.filter(p => p.Crop == params.data.crop).flatMap(p => p.MaterialTypeGenders.filter(p => p.MaterialType == params.data.materialType).flatMap(p => p.Genders))}}} );
      this.columnDefs.push({ field: 'blinPair', headerName : 'BlinPair', headerTooltip: 'BlinPair',  width : 165, editable: this.allowEdit,
        cellStyle: (params: any) => {  
          return params.data.materialType == "ALIN" && (params.data.blinPair == undefined || params.data.blinPair == "") ? this.styleRequired : null;       
       }});
    }
    if (this.selectedCrop.Name !== 'WHE' && this.tandemCrops.includes(this.selectedCrop.Name))
      this.columnDefs.push({ field: 'projectCode', headerName : 'Project Code*', headerTooltip: 'Project Code',  width : 165, editable: this.allowEdit, tooltipValueGetter: (params : any) => {return params.data.gender?.toUpperCase() === 'A' && params.data.projectCode ? 'Project code should be blank for Gender A' : ''},
        cellStyle: (params: any) => {
          if (["CANO","MIL","RICE","SORG","SUN"].includes(params.data.crop)) {
            if (params.data.gender?.toUpperCase() === 'A' && params.data.projectCode)
              return this.styleRequired;
            if (!params.data.projectCode && params.data.gender?.toUpperCase() !== 'A')
              return this.styleRequired;
          }
          return null;    
       }});
  }

  retrieveData() {
    this.fileName = '';
    this.selectedCodeType = this.codingTypes[0];
    this.setCodingColumns();
    let postData : any = {};
    postData['crop'] = this.selectedCrop.Name;
    postData['program'] = this.selectedProgram?.code;
    postData['year'] = this.selectedYear;
    if (this.searchBy == "CVN") {
      postData['geIds'] = [];
      postData['cvn'] = this.idList;      
    } else {
      postData['geIds'] = this.idList.filter(id => !isNaN(Number(id))).map(id => Number(id));
      if (postData['geIds'].length === 0) {
        this.customMessageService.showMessage({severity: "warn",summary: "Invalid GeIds", detail: "Only numeric values are allowed." });
        return;
      }
      postData['cvn'] = [];
    }
    this.rowData.splice(0);
    this.inventorsList.splice(0);
    this.invalidIds.splice(0);
    this.apiService.postData("SearchCodingData", postData, false, true).subscribe({
      next: (response: any) => {
        this.getUserGridPreferences(this.selectedCrop.Name + ":" + 'codePage',false, false);       
        let data = response;
        
        this.validValues = data.validValues;
        if (data && data?.result?.length > 0) {         
          setTimeout(() => {
            let validValues = data.validValues;
            if (this.selectedCrop.Name === 'CORN')
              this.addTIMaterials(data.result, this.columnDefs);
            this.addTraitCols(validValues);
            const codingPageData: any = new Object();
            const ids : any = this.idList;
            if (this.searchBy == "CVN") {
              data.result.sort(function (a : any, b : any) {
                return ids.indexOf(a.cvn) - ids.indexOf(b.cvn);
              });
            } else {
              let searchIds : any = [];
              ids.forEach((ele : any) => searchIds.push(Number(ele)));              
              data.result.sort(function (a : any, b : any) {
                return searchIds.indexOf(Number(a.geId)) - searchIds.indexOf(Number(b.geId));
              });
            }
            codingPageData.data = [...data.result];
            codingPageData.crop = this.selectedCrop;
            codingPageData['userGridPreference'] = this.userGridPreference;
            codingPageData.columnDefs = this.columnDefs;
            if (this.searchBy == "CVN") {
              codingPageData['geIds'] = [];
              codingPageData['cvn'] = this.idList;      
            } else {
              codingPageData['cvn'] = [];
              codingPageData['geIds'] = this.idList;    
            }
            StaticFields.codingPageData = codingPageData;              
            this.collapseHistory = this.collapseSearch = true;
            this.collapseResults = false;  
            this.showSearch = false;
            this.rowData = codingPageData.data;
            setTimeout(() => {
              this.onCodingTypeChanged();
            }, 100);    
            //this.inventorHeaderNames = [];     
          }, 100);
          let validGeIds: string[] = this.searchBy == "CVN" ? data.result.map((p: any) => p.cvn) : data.result.map((p: any) => p.geId.toString());
          this.invalidIds = this.idList.filter(id => !validGeIds.includes(id));
          if (this.invalidIds.length > 0) {
            this.customMessageService.showMessage({'severity': 'warn', summary: 'Invalid GEs', detail: `${this.invalidIds.length} invalid GEs were found and could not be loaded. Please check invalid GEs for details.`});
            this.showSearch = true;
          }
        }
        else {
          this.customMessageService.showMessage({severity: "warn",summary: "No Data Found", detail: "There was no data found for selected combination" })
        }     
      }
    });
  }

  addTIMaterials(data: any, colDefs: ColDef[], materialCols?: string[]) {
    if (!materialCols)
      materialCols = Object.keys(data[0]).filter(k => k.includes("~"));
    materialCols.forEach(col => {
      colDefs.push({ field: col, headerName : this.capitalizeHeader(col.split('~')[0], false), width : 165, 
        editable: (params : any) => {
          return params.data.sendToTI && (col.split('~')[1] === params.data.parentRole || params.data.parentRole === 'Both');
        },
        cellStyle: (params: any) => {  
          return params.data.sendToTI && !params.data[col] && (params.data.parentRole === 'Both' || params.data.sendToTI && col.split('~')[1] === params.data.parentRole) ? this.styleRequired : null;       
        }
      });
    });
  }

  addTraitCols(validValues: any) {
    validValues.forEach((ele : any) => {
      const header = this.capitalizeHeader(ele.traitName, false);
      if (ele.vvsType == "RANG") {     
        const members = ele.validValue.members[0];
        const isEditableColumn = ele.traitName.toLowerCase() === 'yrcoded' && this.selectedYear ? false : this.allowEdit;
        this.columnDefs.push( { field: ele.traitName.toLowerCase(), headerName: (ele.isRequiredTrait === true ? `${header}*` : header), headerTooltip:`Enter a value between ${members['lowerValue']} to ${members['upperValue']}`, editable: isEditableColumn, filter: 'agTextColumnFilter', width : 165,
          cellEditor: 'agNumberCellEditor',
          cellEditorParams: {
            values : ele.validValue.members               
          },  
          cellStyle: params => {
            let style: any = ele.isRequiredTrait === true && !params.data[ele.traitName.toLowerCase()] ? this.styleRequired : null;
            if ((params.value !== "" && (Number(params.value) < members['lowerValue'] || Number(params.value) > members['upperValue']))) {
              style = style ? {"border": "1px solid red", backgroundColor: "orange"} : {backgroundColor: "orange"};
            } else {
              style = style ? this.styleRequired : null;
            }
            return style;
          },
          valueParser: params => Number(params.newValue)
        });
      } else {
        const members : any[] = ele.validValue.members.map((e: any) => e.rangeName);      
        this.columnDefs.push( { field: ele.traitName.toLowerCase(), headerName: (ele.isRequiredTrait === true ? `${header}*` : header), headerTooltip:ele.traitName , editable: this.allowEdit, filter: 'agTextColumnFilter', width : 165,
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values : members,
            searchType: 'match',
            allowTyping: true,
            filterList: true,
            highlightMatch: true
          } as IRichCellEditorParams,
          cellStyle: (params: any) => {  
            return ele.isRequiredTrait === true && !params.data[ele.traitName.toLowerCase()] ? this.styleRequired : null;       
          }
        },)
      }                
    });
  }

  capitalizeHeader(header: string, splitNCapitalize: boolean) {
    if (splitNCapitalize) {
      const parts = header.split('_');
      parts[0] = parts[0].toUpperCase();
      return parts.join('_');
    }
    return header.charAt(0).toUpperCase() + header.slice(1);
  }

  exportExcel(gridApi: any) { 
    this.commonService.downloadExcelFileAPI(gridApi, [], null, true, null, null);
  }

  openTemplateModal(type: string) {
    this.templateType = type;
    this.showSearch = false;
    this.showTemplateModal = true;
  }

  handle(event: any, isTIImport: boolean) {
    this.loader.setMessage('Loading...'); 
    setTimeout(() => {
      const file = event.target.files[0];
        if (typeof Worker !== 'undefined') {
          const worker = new Worker(new URL('../.././app.worker', import.meta.url), { type: 'module' });  
          worker.onmessage = ({ data }) => {
            this.fillGridWithData(data, isTIImport);
          };
          worker.onerror = errorEvent => {
            const formData = new FormData();
            formData.append('file', file);
            this.apiService.postData("GetDecryptedExcelFileData", formData, false, false).subscribe({
              next: (response: any) => {             
                this.fillGridWithData(response, isTIImport);              
              }           
            });
          };
          worker.postMessage(file);
          this.fileName = file.name;
          event.target.value = "";
        } else {
          console.log("Worker not supported.");
        }
    }, 600);
  }

  fillGridWithData(data: any, isTIImport: boolean) {
    if (data.data?.length == 0){
      this.loader.clearMessage();
      this.customMessageService.showMessage({'severity': 'error', summary: 'No Data', detail: "No Data in Imported File."}); 
      return; 
    }
    const sheets = Object.getOwnPropertyNames(data);
    if (sheets.length > 0) {
      let excelData: any[] = data[<any>(sheets[0])];
      if (excelData.length > 0) {
        if (isTIImport)
          this.fillTIGrid(excelData);
        else {
          const inventorField = Object.keys(excelData[0]).find(col => col.toUpperCase().trim().replace('*', '') === 'INVENTORLEIDS');
          let leIds = [...new Set(([].concat(...excelData.filter(p => p[inventorField]).map(p => p[inventorField].toString().split(',')))).map(id => id.trim()))].join(",");
          if (leIds) {   
            this.msalService.acquireTokenSilent({ scopes: [this.config.cradle.scope] }).subscribe((cradleResponse : any) => {           
              this.apiService.getCradleOData(`LegacyAddressAssocs?$filter=LeId in (${leIds})&$expand=SuggestedPerson,SuggestedOrganization&$select=LeId,PersonId,OrganizationId`, cradleResponse.accessToken, false).subscribe((result: any) => { 
                if (result.value.length > 0) {
                  let leInfoDictionary: { [key: number]: string } = result.value.reduce((leInfo: any, item: any) => {
                    leInfo[item.LeId] = item.SuggestedOrganization != null ? item.SuggestedOrganization.Name : `${item.SuggestedPerson.LastName}, ${item.SuggestedPerson.FirstName}`;
                    return leInfo;
                  }, {});
                  this.fillGrid(excelData, leInfoDictionary);
                }
                else {
                  this.fillGrid(excelData);
                  this.customMessageService.showMessage({'severity': 'warn', summary: 'Invalid LeIds', detail: `LeIds Not found ${leIds}`});     
                }
              });  
            });     
          } 
          else {
            this.fillGrid(excelData);
          }
        }
      }  
    } else {
      this.loader.clearMessage();
      this.customMessageService.showMessage({'severity': 'warning', summary: 'Invalid File', detail: "Node a valid code file."});  
    }
  }

  fillGrid(excelData: any[], leInfoDictionary: { [key: number]: string } = null) {
    StaticFields.codingPageData = null;
    this.rowData.splice(0);
    this.inventorsList.splice(0);
    const mappedCols: any = [];
    const matType = ['MATTYPE', 'MATERIALTYPE', 'MAT_TYPE', 'MATERIAL_TYPE', 'INTENDED MATTYPE', 'INTENDED MATERIALTYPE'];
    const projectCode = ['PROJECTCODE', 'PROJECT CODE', 'PRJCODE', 'PRJ CODE'];
    const interval = setInterval(() => {
      if (this.columnDefs.length > 0) {
        clearInterval(interval);
        let duplicateColFound = false;
        Object.keys(excelData[0]).forEach(k => {
          if (matType.findIndex(c => c.trim().replace('*', '') === k.toUpperCase().trim().replace('*', '')) > -1) {
            if (mappedCols.findIndex((c: any) => c.mappedCol === 'materialType') > -1)
              duplicateColFound = true;
            mappedCols.push({ header: k, mappedCol: 'materialType'});
          } else if (projectCode.findIndex(c => c.trim().replace('*', '') === k.toUpperCase().trim().replace('*', '')) > -1) {
            if (mappedCols.findIndex((c: any) => c.mappedCol === 'projectCode') > -1)
              duplicateColFound = true;
            mappedCols.push({ header: k, mappedCol: 'projectCode'});
          } else if (!(k.toUpperCase().includes('INVENTOR') && k.toUpperCase().trim().replace('*', '') !== 'INVENTORLEIDS')) {
            let foundCol = this.columnDefs.find(c => c.headerName.toUpperCase().trim().replace('*', '') === k.toUpperCase().trim().replace('*', ''));
            if (foundCol) {
              if (mappedCols.findIndex((c: any) => c.mappedCol === foundCol.field) > -1)
                duplicateColFound = true;
              mappedCols.push({ header: k, mappedCol: foundCol.field});
            }
          }
        });
        if (mappedCols.findIndex((c: any) => c.mappedCol === 'program') === -1 && this.selectedProgram)
          mappedCols.push({ header: 'program', mappedCol: 'program'});
        if (mappedCols.findIndex((c: any) => c.mappedCol === 'yrcoded') === -1 && this.selectedYear)
          mappedCols.push({ header: 'yrcoded', mappedCol: 'yrcoded'});
        if (duplicateColFound) {
          this.columnDefs.splice(0);
          this.loader.clearMessage();
          this.customMessageService.showMessage({'severity': 'error', summary: 'Duplicate Columns', detail: "Sheet contains duplicate columns."}); 
          return;
        }      

        let inventorColumns: string [] = [];
        const inventorField = mappedCols.find((c: any) => c.mappedCol === 'inventorLeIds')?.header;
        if (leInfoDictionary != null) {
          let inventorCount = 0;
          excelData.forEach(row => {           
            inventorCount =  inventorCount < row[inventorField].toString().split(",").length ? row[inventorField].toString().split(",").length : inventorCount;
          });
          for (let i = 0; i < inventorCount; i++) {
            let inventorHeader = `Inventor ${i + 1}`;  
            let inventorColumn = `Inventor${i + 1}`;  
            mappedCols.push({ header: inventorHeader, mappedCol: inventorColumn,  mappedColIndex: i});                        
            inventorColumns.push(inventorColumn);
            const idx = this.columnDefs.findIndex(c => c.field === 'inventorLeIds');
            this.columnDefs.splice(idx + i + 1, 0, { field: inventorColumn, headerName : inventorHeader, headerTooltip : inventorHeader, editable: false, width : 165} );
          }
        }

        const data: any = [];
        //const inventors: number[] = [];
        excelData.forEach(row => {
        //  inventors.splice(0);
          let item: any = {};
          item.crop = this.selectedCrop.Name;
          item.sendToTI = false;    
          // if (row['inventor1'] && Number(row['inventor1']))
          //   inventors.push(row['inventor1']);
          // if (row['inventor2'] && Number(row['inventor2']))
          //   inventors.push(row['inventor2']);
          // if (row['inventor3'] && Number(row['inventor3']))
          //   inventors.push(row['inventor3']);
          // if (inventors.length > 0)
          //   item['inventorLeIds'] = inventors.join();         

          mappedCols.forEach((col: any) => {
            if (row[col.header]) {
              const colVVS = this.validValues.find((vv: any) => vv.traitName === col.mappedCol.toUpperCase());
              if (colVVS) {
                if ((colVVS.vvsType === 'RANG' && Number(row[col.header])) || (colVVS.validValue.members.map((e: any) => e.rangeName.toUpperCase()).includes(row[col.header].toString().toUpperCase()))) {
                  item[col.mappedCol] = colVVS.vvsType === 'RANG' ? Number(row[col.header]) : row[col.header].toString();
                  if (this.selectedYear && col.mappedCol === 'yrcoded')
                    item[col.mappedCol] = Number(this.selectedYear);
                }
              } else {
                if (col.mappedCol === 'sendToTI') {
                  item[col.mappedCol] = row[col.header] === true || row[col.header].toString().toUpperCase() === 'TRUE' ? true : false;
                  if (this.columnDefs.length > 0 && this.columnDefs.findIndex(c => c.field.includes("~")) === -1)
                    item[col.mappedCol] = false;
                } else if (col.mappedCol === 'geId')
                  item[col.mappedCol] = Number(row[col.header]);
                else if (col.mappedCol === 'inventorLeIds') {
                  if (row[col.header]) {
                    const leIds: string[] = row[col.header].toString().split(",").map((id: string) => id.trim());
                    item[col.mappedCol] = leIds.length > 0 && leInfoDictionary !== null ? leIds.filter(id => id in leInfoDictionary).join() : '';
                  } else
                    item[col.mappedCol] = '';
                } else if (col.mappedCol === 'program' && this.selectedProgram)
                  item[col.mappedCol] = this.selectedProgram.code;     
                else if (col.mappedCol === 'parentRole')
                  item[col.mappedCol] = row[col.header] ? row[col.header].toUpperCase() === 'MALE' ? 'Male' : row[col.header].toUpperCase() === 'FEMALE' ? 'Female' : row[col.header].toUpperCase() === 'BOTH' ? 'Both' : row[col.header] : row[col.header];           
                else
                  item[col.mappedCol] = row[col.header];
              }
            } else {
              if (col.mappedCol === 'program' && this.selectedProgram)
                item[col.mappedCol] = this.selectedProgram.code;

              if (this.selectedYear && col.mappedCol === 'yrcoded')
                item[col.mappedCol] = Number(this.selectedYear);

              if (inventorColumns.includes(col.mappedCol)) { 
                item[col.mappedCol] = '';    
                if (row[inventorField]) {
                  let leIds: any[] = row[inventorField].toString().split(",").map((id: string) => id.trim());
                  if (leIds.length > col.mappedColIndex && leIds[col.mappedColIndex] in leInfoDictionary) {
                    item[col.mappedCol] = leInfoDictionary[leIds[col.mappedColIndex]];
                  } 
                }
              }
            }
          });
          data.push(item);
        });
        if (!data[0].geId && !data[0].cvn) {
          this.columnDefs.splice(0);
          this.loader.clearMessage();
          this.customMessageService.showMessage({'severity': 'error', summary: 'Invalid File', detail: "Sheet doesn't contain GE Id or GE Name."}); 
          return;
        } else {
          const isCVNSearch = !data[0].geId;
          const geIdOrName = isCVNSearch ? data.map((d: any) => d.cvn) : data.map((d: any) => d.geId);
          this.apiService.postData('GetGEInfo', {cropName: this.selectedCrop.Name, geList: geIdOrName, selectQuery: '&$select=GeId,Name,Pedigree,Type'}, false, false).subscribe((res: any) => {
            this.invalidIds.splice(0);
            data.forEach((d: any) => {
              const foundGE = isCVNSearch ? res.find((p: any) => p.name == d.cvn) : res.find((p: any) => p.geId == d.geId)
              if (foundGE) {
                d.geId = foundGE.geId;
                d.cvn = foundGE.name;
                d.pedigree = foundGE.pedigree;
                d.currentMaterialType = foundGE.type.id;
                let leIds: any[] = d["inventorLeIds"] ? d["inventorLeIds"].toString().split(",").map((id: string) => id.trim()) : [];
                if (leIds.length > 0 && leIds[0]) {
                  for (let i = 0; i < inventorColumns.length; i++) {
                    if (leIds.length > i) {
                      const inventor = { leId: leIds[i], name: d[inventorColumns[i]] };
                      const foundItem: any = this.inventorsList.find((inv: any) => inv.geId === d['geId']);
                      if (foundItem)
                        foundItem.inventors.push(inventor);
                      else
                        this.inventorsList.push({ geId : d['geId'], inventors: [inventor] });
                    }
                  } 
                }
              } else {
                this.invalidIds.push(isCVNSearch ? d.cvn : d.geId);
                d.geId = null;
              }
            });
            if (this.invalidIds.length > 0) {
              this.customMessageService.showMessage({'severity': 'warn', summary: 'Invalid GEs', detail: `${this.invalidIds.length} invalid GEs were found and could not be loaded. Please check invalid GEs for details.`});
              this.showSearch = true;
            }
            this.selectedCodeType = this.selCodeType;
            this.showTemplateModal = false;
            this.collapseHistory = this.collapseSearch = true;
            this.collapseResults = false;
            this.rowData = data.filter((d: any) => d.geId);
            setTimeout(() => {
              this.onCodingTypeChanged();
              this.loader.clearMessage();
            }, 100);
          });
        }
      }
    }, 1000);
  }

  codeTemplateAction(type: string) {
    let params = new HttpParams();
    params = params.append('crop', this.selectedCrop.Name);
    params = params.append('codingType', this.codingMap[this.selCodeType]);
    if (this.selectedYear)
      params = params.append('year', this.selectedYear);
    if (this.selectedProgram?.code)
      params = params.append('program', this.selectedProgram?.code);
    if (type === "Export")
      this.exportCodeTemplate(params);
    else
      this.importCodingFile(params);
  }

  importCodingFile(params: HttpParams) {
    this.columnDefs.splice(0);
    if (this.selectedCrop.Name === 'CORN') {
      params = params.append('program', this.selectedProgram?.code);
      params = params.append('year', this.selectedYear);
    }
    this.apiService.getData("GetCodingColumns", params, false).subscribe((res: any) => {
      if (res) {
        this.setCodingColumns();
        this.validValues = res.traitInfo;
        if (this.selectedCrop.Name === 'CORN')
          this.addTIMaterials(null, this.columnDefs, res.startingMaterials);
        this.addTraitCols(res.traitInfo);
      }
    });
    document.getElementById('importFile')?.click();
  }

  onTIImportClick() {
    document.getElementById('importTIFile')?.click();
  }

  exportCodeTemplate(params: HttpParams) {
    const columns: string[] = ["GeId","Ge Name","MaterialType*","InventorLeIds*"];
    if (this.selectedCrop.Name === "CORN") {
      columns.push("HeteroticPrefix*");
    }
    if (this.tandemCrops.includes(this.selectedCrop.Name)) {
      columns.push('Gender');
      columns.push('BlinPair');
    }
    if (this.selectedCrop.Name !== 'WHE' && this.tandemCrops.includes(this.selectedCrop.Name))
      columns.push('ProjectCode*');
    if (this.selectedCrop.Name !== 'SOY' && (this.codingMap[this.selCodeType] === "FORW" || this.codingMap[this.selectedCodeType] === "CONV"))
      columns.push(this.codingMap[this.selCodeType] === "FORW" ? 'Suffix*' : 'Suffix');
    if (this.selectedCrop.Name !== 'SOY' && this.codingMap[this.selectedCodeType] === "CONV")
      columns.push('ConvBase*');
    params = params.append('columns', columns.join());
    this.apiService.getExcelTemplate("GenerateCodeTemplate", params).subscribe((res: any) => {
      if (res) { 
        const blob = new Blob([res], { type: 'application/ms-excel' });
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = window.URL.createObjectURL(blob);     
        let fileName = `PCM_${this.selectedCrop.Name}_Coding_${this.customMessageService.getDateString(new Date())}.xlsx`;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }, 100);
      }   
      this.showTemplateModal = false; 
    });
  }

  // addInventorHeaderName(inventorHeaderName: string) {
  //   if (!this.inventorHeaderNames.includes(inventorHeaderName)) {
  //     this.inventorHeaderNames.push(inventorHeaderName);
  //   }
  // }

  onGridPreDestroyed($event: GridPreDestroyedEvent<any,any>) {
    if (!$event.context.showGrouped && StaticFields.codingPageData)
      StaticFields.codingPageData.colState = $event.api.getColumnState();
  }

  saveGridPreferences() {
    const cols = JSON.stringify(this.gridApi.getColumnState());
    if (!this.userGridPreference.appUserId) {
      this.userGridPreference.appUserId = StaticFields.appUserId;
      this.userGridPreference.gridName= this.selectedCrop.Name + ":" + "codePage";
    }
    StaticFields.codingPageData.userGridPreference =  this.userGridPreference.preference = cols;
    this.apiService.putData('SubmitUserGridPreference', this.userGridPreference).subscribe();   
  }

  getGridPreferences() {
    let params = new HttpParams();
    params = params.append('gridName', this.selectedCrop.Name + ":codePage");
    params = params.append('appUserId', StaticFields.appUserId);
    this.apiService.getData('GetUserGridPreferrences', params, false).subscribe((res: any) => { 
      this.userGridPreference = res ? res : new GridPreference();
    }); 
  }

  ValidateCodeAfterFilterCheck() {
    if (this.selectedCodeType) {
      if (this.gridApi.getSelectedRows().length > 0)
        this.customMessageService.showMessage({'severity': 'info', summary: 'Validation', detail: "All grid rows are being submitted for Validation."});
      let filteredData: any = [];
      this.gridApi.forEachNodeAfterFilter((node: any) => {
        filteredData.push(node.data);
      });
      if (this.rowData.length > filteredData.length) {
        this.confirmationService.confirm({
          header: 'Validate Partial Data',
          icon: 'pi pi-exclamation-triangle',
          message: `Do you want to Validate only filtered data ?`,      
          accept: () => {
            this.validateCodeData(filteredData);
          }
        });
      } else
        this.validateCodeData(filteredData);
    }
    else {
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Code Type Validation', detail: "Please Select Code Type"});
    }
  }

  validateCodeData(filteredData: any) {
    if (filteredData.length > 0) {
      if (this.validateCodes(filteredData)) {
        this.validateCodesFromService(filteredData, false);
      }
    } else {
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Validation', detail: "No Data To Submit"});
    }
  }

  SubmitCodeAfterFilterCheck(isBatch: boolean) {
    if (this.selectedCodeType) {
      if (this.gridApi.getSelectedRows().length > 0)
        this.customMessageService.showMessage({'severity': 'info', summary: 'Submission', detail: "All grid rows are being submitted for Coding."});
      let filteredData: any = [];
      this.gridApi.forEachNodeAfterFilter((node: any) => {
        filteredData.push(node.data);
      });
      if (this.rowData.length > filteredData.length) {
        this.confirmationService.confirm({
          header: 'Submit Partial Data',
          icon: 'pi pi-exclamation-triangle',
          message: `Do you want to Submit only filtered data ?`,      
          accept: () => {
            this.submitCodeData(filteredData, isBatch);
          }
        });
      } else
        this.submitCodeData(filteredData, isBatch);
    }
    else {
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Code Type Validation', detail: "Please Select Code Type"});
    }
  }

  submitCodeData(filteredData: any, isBatch: boolean) {
    if (filteredData.length > 0) {
      if (this.validateCodes(filteredData)) {
        this.submitCodes(filteredData, isBatch);
      }
    } else {
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Validation', detail: "No Data To Submit"});
    }
  }

  validateCodes(rowData: any[]): boolean {
    let valid: boolean = true;
    let blinPair = rowData.filter(p => p.materialType == "ALIN" && !p.blinPair);
    if (blinPair.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: "Blin Pair is must for ALIN Material Type", detail: `Please Enter Blin Pair for Geids: ${blinPair.map(p => p.geId).join(",")}`});
      valid = false;
    }

    blinPair = rowData.filter(p => p.blinPair && typeof p.blinPair !== "string");
    if (blinPair.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: "Blin Pair should be a GE Name", detail: `Please Enter valid Blin Pair for Geids: ${blinPair.map(p => p.geId).join(",")}`});
      valid = false;
    }

    let projectCodeCrops = ["CANO","MIL","RICE","SORG","SUN"];
    let projectCode = rowData.filter(p => projectCodeCrops.includes(p.crop) && p.gender?.toUpperCase() !== 'A' && !p.projectCode);
    if (projectCode.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: `Project Code is must for ${projectCode[0].crop}`, detail: `Please Enter Project Code for Geids: ${projectCode.map(p => p.geId).join(",")}`});
      valid = false;
    }
    projectCode = rowData.filter(p => projectCodeCrops.includes(p.crop) && p.gender?.toUpperCase() === 'A' && p.projectCode);
    if (projectCode.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: `Project Code should be blank for Gender A`, detail: `Please clear Project Code for Geids: ${projectCode.map(p => p.geId).join(",")}`});
      valid = false;
    }

    let convBaseCodingType = ["CONV"];
    let convBase = rowData.filter(p => convBaseCodingType.includes(this.codingMap[this.selectedCodeType]) && p.crop !== "SOY" && !p.convBase);
    if(convBase.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: `Conv Base is must for ${convBaseCodingType.join(",")} Coding Type`, detail: `Please Enter numeric Conv Base for Geids: ${convBase.map(p => p.geId).join(",")}`});
      valid = false;
    } 
    convBase = rowData.filter(p => p.convBase && typeof p.convBase !== "string");
    if (convBase.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: "Conv Base should be a GE Name", detail: `Please Enter valid Conv Base for Geids: ${blinPair.map(p => p.geId).join(",")}`});
      valid = false;
    }  

    let hetrForwCodingType = ["HETR","FORW"];
    //let hetrForw = rowData.filter(p => hetrForwCodingType.includes(this.codingMap[this.selectedCodeType]) && ((p.projectCode == undefined ||  p.projectCode?.trim() == "") || (p.materialType == undefined ||  p.materialType == "") || (p.inventorLeIds == undefined ||  p.inventorLeIds == "")));
    let hetrForw = rowData.filter(p => hetrForwCodingType.includes(this.codingMap[this.selectedCodeType]) && (!p.materialType || !p.inventorLeIds));
    if(hetrForw.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: `Material Type, InventorLeIds Must for ${hetrForwCodingType.join(",")} Coding Types`, detail: `Please Enter Required Fields for Geids: ${hetrForw.map(p => p.geId).join(",")}`});
      valid = false;
    }  

    let soyInventorLeIds = rowData.filter(p => this.selectedCodeType == "Fixed Line" && p.crop == "SOY" && (p.inventorLeIds == undefined ||  p.inventorLeIds == ""));
    if(soyInventorLeIds.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: `InventorLeIds is Must for Fixed Line Coding Type`, detail: `Please Enter Required Fields for Geids: ${soyInventorLeIds.map(p => p.geId).join(",")}`});
      valid = false;
    }  
   
    let heteroticPrefixHetrForw = rowData.filter(p => hetrForwCodingType.includes(this.codingMap[this.selectedCodeType]) && p.crop == "CORN" && (p.heteroticPrefix == undefined ||  p.heteroticPrefix?.trim() == ""));
    if (heteroticPrefixHetrForw.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: `HeteroticPrefix is Must for CORN Crop & ${hetrForwCodingType.join(",")} Coding Types`, detail: `Please Enter Heterotic Prefix for Geids: ${heteroticPrefixHetrForw.map(p => p.geId).join(",")}`});
      valid = false;
    }   

    let forwCodingType = ["FORW"];
    let forw = rowData.filter(p => forwCodingType.includes(this.codingMap[this.selectedCodeType]) && p.crop !== "SOY" && (p.suffix == undefined ||  p.suffix?.trim() == ""));
    if(forw.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: `Suffix is Must for ${forwCodingType.join(",")} Coding Types`, detail: `Please Enter Suffix for Geids: ${forw.map(p => p.geId).join(",")}`});
      valid = false;
    } 
    const missigOrigCntry = rowData.filter(p => !p['origcntry']);
    if (missigOrigCntry.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: `ORIGCNTRY is Must for Coding Types`, detail: `Please Enter ORIGCNTRY for Geids: ${missigOrigCntry.map(p => p.geId).join(",")}`});
      valid = false;
    }   
    return valid;
  }

  validateTIRequests(tiData: any[]): boolean {
    let valid: boolean = true;
    let parentRole = tiData.filter(p => p.parentRole == undefined ||  p.parentRole == "");
    if (parentRole.length > 0) {
      this.customMessageService.showMessage({'severity': 'warn', summary: "Parent Role Required", detail: `Please Enter Parent Role for Geids: ${parentRole.map(p => p.geId).join(",")}`});
      valid = false;
    }
    const materialCols = Object.keys(tiData[0]).filter(k => k.includes("~"));
    for (let i = 0; i < tiData.length; i++) {
      if (tiData[i].parentRole === 'Male') {
        valid = materialCols.filter(col => col.endsWith('Male') && !tiData[i][col]).length === 0;
      } else if (tiData[i].parentRole === 'Female') {
        valid = materialCols.filter(col => col.endsWith('Female') && !tiData[i][col]).length === 0;
      } else {
        valid = materialCols.filter(col => !tiData[i][col]).length === 0;
      }
      if (!valid) {
        this.customMessageService.showMessage({'severity': 'warn', summary: "SIID Required", detail: `Please provide SIID(s) for marked cells`});
        break;
      }
    }
    return valid;
  }

  submitCodes(filteredData: any, isBatch: boolean) {   
    if (this.rowData.length > 0) {
      if (isBatch) {
        this.validateCodesFromService(filteredData, true);
      } else {
        const chunkCount = 10;
        let cntr = 0;
        const rows = this.rowData.slice(0, chunkCount);
        this.loader.setMessage('Loading...');
        this.showLoader = true;
        this.SubmitCodeInLoop(rows, chunkCount, cntr);
      }
    }
  }

  SubmitCodeInLoop(rows: any, chunkCount: number, cntr: number) {
    const postData = this.createPostData(rows, null);
    if (postData.inbredCodingArgs.length === 0) {
      this.customMessageService.showMessage({severity: "warn",summary: "InvalidData", detail: `No valid data found.` });
      return;
    }
    this.apiService.putData('SubmitCodes', postData, false, false).subscribe((res: any) => {
      if (res.msgType === 'success') {
        this.rowData.forEach((r: any) => {
          const foundRow = res.data.find((d: any) => r.geId === d.geId);
          if (foundRow)
            r.codedName = foundRow.codedName;
        });
        if (this.columnDefs.findIndex((col: any) => col.field === 'codedName') === -1) {
          this.columnDefs.splice(5, 0, { field: 'codedName', headerName : 'Coded Name', width : 165, headerTooltip : 'New Coded Name' });
        }
        this.gridApi.setGridOption("columnDefs", this.columnDefs);
        this.loader.clearMessage();
        cntr = cntr + chunkCount;
        if (cntr < this.rowData.length) {
          this.customMessageService.showMessage({severity: "success",summary: "Partially Done", detail: `${cntr} of ${this.rowData.length} records processed.` });
          const rows = this.rowData.slice(cntr, chunkCount + cntr);
          this.SubmitCodeInLoop(rows, chunkCount, cntr);
        } else {
          this.showLoader = false;
          this.customMessageService.showMessage({severity: "success",summary: "Coding Done", detail: `All ${this.rowData.length} records processed.` });
          let tiRequests = this.rowData.filter(row => row.sendToTI == true);  
          if (tiRequests.length > 0) {
            if (this.validateTIRequests(tiRequests)) {
              this.validateOrSubmitTIRequestsFromService('SubmitTIRequests', tiRequests, true, this.rowData, this.columnDefs, this.gridApi);
            }
          }
        }
      } else {
        this.setErrorCol(res.message, this.rowData, this.columnDefs, this.gridApi);
      }
    });
  }

  setErrorCol(errorDict: any, rowData: any, colDef: ColDef[], gridApi: any) {
    rowData.forEach((r: any) => {
      if (r.geId in errorDict)
        r.error = errorDict[r.geId];
    });
    if (colDef.findIndex((col: any) => col.field === 'error') === -1) {
      colDef.splice(5, 0, { field: 'error', headerName : 'Error', width : 165, headerTooltip : 'Validation Error' });
    }
    gridApi.setGridOption("columnDefs", colDef);
    this.loader.clearMessage();
  }

  removeErrorCol() {
    const idx = this.columnDefs.findIndex((col: any) => col.field === 'error')
    if (idx > -1) {
      this.columnDefs.splice(idx, 1);
      this.gridApi.setGridOption("columnDefs", this.columnDefs);
    }
  }

  validateOrSubmitTIRequestsFromService(methodName: string, tiData: any[], showLoading: boolean, rowData: any, colDef: ColDef[], gridApi: any) {
    const tiPostData = this.getTIPostData(tiData, colDef);
    this.apiService.putData(methodName, tiPostData, true, showLoading).subscribe((res: any) => {
      if (res.msgType !== 'success') {
        this.setErrorCol(res.data, rowData, colDef, gridApi);
      }
    });
  }

  getTIPostData(tiData: any[], colDefs: ColDef[], hasStatingMaterials: boolean = false) {
    let tiCodeTemplateDTOs: TICodeTemplateDTO [] = [];  
    const materialCols = colDefs.filter(col => col.field.includes("~"));
    let validCols: string[]; 
    tiData.forEach((d: any) => {
      const tiCodeTemplateStartingMaterials: TICodeTemplateStartingMaterial[] = hasStatingMaterials ? d.startingMaterials : [];
      if (d.parentRole === 'Male') {
        validCols = materialCols.filter(col => col.field.endsWith('Male')).map(col => col.field);
      } else if (d.parentRole === 'Female') {
        validCols = materialCols.filter(col => col.field.endsWith('Female')).map(col => col.field);
      } else {
        validCols = materialCols.map(col => col.field);
      }
      validCols.forEach(col => {
        tiCodeTemplateStartingMaterials.push({sIId: d[col], geneticProfile: (col.split('_')[0]).toUpperCase().split(',')})
      });
      tiCodeTemplateDTOs.push({ 
        cropGenusId : d.crop, 
        requestType : "TI", 
        requester : StaticFields.userInfo.onPremisesSamAccountName, 
        programCode : d.program, 
        comments : d.comments?.trim(),
        referenceId: d.geId,
        baseGEId: d.geId,
        parentRole: d.parentRole, 
        yearCoded: d.yrcoded, 
        startingMaterials: tiCodeTemplateStartingMaterials
      });
    });

    let postData : any = {};     
    postData['userName'] = StaticFields.userInfo.onPremisesSamAccountName;
    postData['tiCodeTemplateDTOs'] = tiCodeTemplateDTOs;
    return postData;
  }

  validateCodesFromService(filteredData: any, shallSubmit: boolean) {
    if (filteredData.length > 0) {
      const convBases: string[] = filteredData.filter((d: any) => d.convBase).map((d: any) => d.convBase.trim());
      const blinPair: string[] = filteredData.filter((d: any) => d.blinPair).map((d: any) => d.blinPair.trim());
      const geNames = convBases.concat(blinPair);
      if (geNames.length > 0) {
        this.apiService.postData('GetGEInfo', {cropName: this.selectedCrop.Name, geList: geNames, selectQuery: '&$select=GeId,Name'}, false, false).subscribe((res: any) => {
          this.validateAfterGECheck(filteredData, res, shallSubmit);
        });
      } else
        this.validateAfterGECheck(filteredData, null, shallSubmit);
    }
  }

  validateAfterGECheck(filteredData: any, geList: any, shallSubmit: boolean) {
    const postData = this.createPostData(filteredData, geList); 
    if (postData.inbredCodingArgs.length === 0) {
      this.customMessageService.showMessage({severity: "warn",summary: "InvalidData", detail: `No valid data found.` });
      return;
    } 
    this.loader.setMessage('Loading...');
    this.apiService.putData('ValidateCodes', postData, true, false).subscribe((res: any) => {
      if (res.msgType === 'success') {
        let tiRequests = filteredData.filter((row: any) => row.sendToTI == true); 
        const isTIValidated = tiRequests.length > 0 ? this.validateTIRequests(tiRequests) : false;
        if (shallSubmit) {
          this.SubmitForCodingAfterValidation(tiRequests, isTIValidated, postData, `${postData.inbredCodingArgs.length} record(s) submitted for coding. You will get an email once process is complete.`);
          if (filteredData.length === this.rowData.length) {
            this.rowData.splice(0);
            this.collapseHistory = false;
            this.collapseResults = this.collapseSearch = true;
          } else {
            this.rowData = this.rowData.filter(r => filteredData.findIndex((d: any) => d.geId === r.geId) === -1);
            this.gridApi.setFilterModel(null);
          }
        } else {
          this.removeErrorCol();
          if (isTIValidated) {
            this.validateOrSubmitTIRequestsFromService('ValidateTIRequests', tiRequests, true, this.rowData, this.columnDefs, this.gridApi);
          } else 
            this.loader.clearMessage();
        }
      } else {
        if (shallSubmit && filteredData.length > Object.keys(res.data).length) {
          postData.inbredCodingArgs = postData.inbredCodingArgs.filter((a: InbredCodingArg) => !(a.geId in res.data));
          let tiRequests = filteredData.filter((row: any) => !(row.geId in res.data) && row.sendToTI == true); 
          const isTIValidated = tiRequests.length > 0 ? this.validateTIRequests(tiRequests) : false;
          this.SubmitForCodingAfterValidation(tiRequests, isTIValidated, postData, `Remaining ${postData.inbredCodingArgs.length} record(s) submitted for coding. You will get an email once process is complete.`);
          const remainingdata = this.rowData.filter(r => r.geId in res.data);
          this.rowData.splice(0);
          this.rowData = [...remainingdata];
        }
        this.setErrorCol(res.data, this.rowData, this.columnDefs, this.gridApi);
      }
    });  
  }

  SubmitForCodingAfterValidation(tiRequests: any, isTIValidated: boolean, postData: any, msg: string) {
    this.loader.clearMessage();
    postData['newGuid'] = this.commonService.getGUID();
    postData['isBatch'] = true;
    if (isTIValidated)
      postData['tiCodeTemplateDTOs'] = this.getTIPostData(tiRequests, this.columnDefs).tiCodeTemplateDTOs;
    postData['isValidated'] = true;
    postData['fileName'] = this.fileName ? this.fileName : "Grid Submission";
    this.apiService.putData('SubmitCodes', postData, false, false).subscribe();
    this.customMessageService.showMessage({'severity': 'info', summary: 'Code Batch Submitted', detail: msg});
    const newRow = { 
      id: postData['newGuid'],
      fileName: postData['fileName'],
      status: 'Submitted',
      count: postData.inbredCodingArgs.length,
      tiCount: postData.tiCodeTemplateDTOs ? postData.tiCodeTemplateDTOs.length : 0,
      crop: postData['crop'],
      codingType: postData['codingType'],
      user: StaticFields.userInfo.displayName,
      codedData: this.setCodeRowData(postData)
    }
    this.historyData.unshift(newRow);
    if (this.histGridApi)
      this.histGridApi.applyTransaction({ add: [newRow], addIndex: 0 });
  }

  setCodeRowData(postData: any) {
    const traitIds = [...new Set(postData.inbredCodingArgs.map((a: InbredCodingArg) => a.traitValues).flat().map((t: TraitValue) => t.traitId))];
    const codeData: any = [];
    postData.inbredCodingArgs.forEach((a: InbredCodingArg) => {
      const tiData: TICodeTemplateDTO = postData['tiCodeTemplateDTOs'] ? postData['tiCodeTemplateDTOs'].find((d: TICodeTemplateDTO) => d.referenceId === a.geId) : null;
      const data: any = {
        geId: a.geId,
        submittedName: a.geName,
        blinPair: a.blinPair,
        convBase: a.convBase,
        gender: a.gender,
        heteroticPrefix: a.heteroticPrefix,
        inventorLeids: a.inventorLeids.join(),
        materialType: a.materialType,
        projectCode: a.projectCode,
        suffix: a.suffix,
        sentToTI: postData['crop'] === 'CORN' && tiData ? 'True' : 'False'
      }
      if (postData['crop'] === 'CORN' && tiData) {
        data.requestType = tiData.requestType;
        data.requester = tiData.requester;
        data.programCode = tiData.programCode;
        data.yearCoded = tiData.yearCoded;
        data.parentRole = tiData.parentRole;
        data.comments = tiData.comments;
        data.startingMaterials = JSON.stringify(tiData.startingMaterials);
      }
      traitIds.forEach(id => {
        const foundTrait: TraitValue = a.traitValues.find((t: TraitValue) => t.traitId === id);
        data[`${id}_trait_${foundTrait.traitName}`] = foundTrait?.value;
      })
      codeData.push(data);
    });
    return codeData;
  }

  createPostData(rowData: any[], geList: any): any {
    rowData.forEach((d: any) => d.error = "");
    let inbredCodingArgs: InbredCodingArg [] = [];   
    rowData.map((row: any) => inbredCodingArgs.push({ geId: row.geId, geName: row.cvn, convBase: geList ? geList.find((ge: any) => ge.name === row.convBase)?.geId : null, blinPair: geList ? geList.find((ge: any) => ge.name === row.blinPair)?.geId : null, materialType: row.materialType, gender: row.gender, 
      heteroticPrefix: row.heteroticPrefix?.trim(), inventorLeids: row.inventorLeIds?.length > 0 ? row.inventorLeIds?.split(",").map(Number): [], projectCode: (row.projectCode || row.gender?.toUpperCase() === 'A' ? (row.gender?.toUpperCase() === 'A' ? '' : row.projectCode) : ''), suffix: row.suffix?.trim(), traitValues: () => {
      let traits: TraitValue[] = [];
      this.validValues.forEach((ele : any) => {
        if (row[ele.traitName.toLowerCase()])
          traits.push({traitId: ele.traitId, value: row[ele.traitName.toLowerCase()], traitName: ele.traitName});
      });
      return traits;
    }}));
    inbredCodingArgs.forEach(ele => ele.traitValues =  ele.traitValues());
    let postData : any = {};
    postData['crop'] = this.selectedCrop.Name;
    postData['codingType'] = this.codingMap[this.selectedCodeType];
    postData['appUserId'] = StaticFields.appUserId; 
    postData['userName'] = StaticFields.userInfo.onPremisesSamAccountName;
    postData['inbredCodingArgs'] = inbredCodingArgs.filter(a => a.geId);
    return postData;
  }

  onGridReady($event: GridReadyEvent<any>) {
    this.gridApi = $event.api;
    let savedCols = null;
    if (StaticFields.codingPageData?.colState){
      savedCols = StaticFields.codingPageData?.colState;
      this.gridApi.applyColumnState({ state: savedCols, applyOrder: true });
    }
    else if (this.userGridPreference?.preference) {
       savedCols = JSON.parse(this.userGridPreference.preference);
       this.gridApi.applyColumnState({ state: savedCols, applyOrder: true });     
    }
  }

  onHistGridReady($event: GridReadyEvent<any>) {
    this.histGridApi = $event.api;
    this.histGridApi.setColumnsVisible(['tiCount', 'submitTI'], this.selHistoryCrop.Name === "CORN");
  }

  onTIGridReady($event: GridReadyEvent<any>) {
    this.tiGridApi = $event.api;
  }

  onCellEditingStopped(event: CellEditingStoppedEvent) {
    this.editCellEvent(event, this.gridApi);
  }

  editCellEvent(event: CellEditingStoppedEvent, gridApi: any) {
    const col = event.column?.getColId()
    if (col == "inventorLeIds") {
      event.data.inventorLeIds = event.oldValue     
    } else if (col === 'sendToTI') {
      if (event.newValue) {
        if (event.data['hetGrp'] && event.data['hetGrp'].toUpperCase() === 'SSS')
          event.data.parentRole = 'Female';
        else if (event.data['hetGrp'] && event.data['hetGrp'].toUpperCase() === 'NSS')
          event.data.parentRole = 'Male';
      } else {
        const materialCols = Object.keys(event.data).filter(k => k.includes("~"));
        event.data.comments = event.data.parentRole = null;
        materialCols.forEach(col => event.data[col] = '');
      }
    } else if (col === 'parentRole') {
      const materialCols = Object.keys(event.data).filter(k => k.includes("~"));
      let colsToEdit: string[] = [];
      if (event.data.parentRole === 'Male') {
        colsToEdit = materialCols.filter(col => col.endsWith('Female'));
      } else if (event.data.parentRole === 'Female') {
        colsToEdit = materialCols.filter(col => col.endsWith('Male'));
      } 
      colsToEdit.forEach(col => event.data[col] = '');
    }
    gridApi.redrawRows({ rowNodes: [event.node] });
  }

  onTICellEditingStopped(event: CellEditingStoppedEvent) {
    this.editCellEvent(event, this.tiGridApi);
  }

  onTIPasteEnd(event: PasteEndEvent<any,any>) {
    this.tiGridApi.redrawRows();
  }

  onPasteEnd(event: PasteEndEvent<any,any>) {
    this.gridApi.redrawRows();
  }

  onFilerChanged($event: FilterChangedEvent<any,any>) {
    this.codeGridFilterBar.updateFilters(this.gridApi, false, this);
  }

  disableImport(type: string): boolean {
    if (type === 'Export')
      return !(this.selectedCrop && this.selCodeType);
    else {
      if (this.selectedCrop?.Name === 'CORN')
        return !(this.selectedCrop && this.selCodeType && this.selectedProgram && this.selectedYear);
      else  
        return !(this.selectedCrop && this.selCodeType);
    }
  }

  getHistory() {
    let postData : any = {};
    postData['crop'] = this.selHistoryCrop.Name;
    postData['codedBy'] = this.selUser ? this.selUser.id : (StaticFields.userClaim.isPCMSuperUser || StaticFields.userClaim.isPCMAdmin) ? null : StaticFields.appUserId;
    postData['beginDate'] = this.beginDate?.toISOString();
    postData['endDate'] = this.endDate?.toISOString();
    this.historyData.splice(0);
    this.apiService.postData('GetCodeHistory', postData, false).subscribe((res: any) => {
      this.historyData = res;  
      if (this.historyData.length === 0)
        this.customMessageService.showMessage({'severity': 'warn', summary: "Not Found", detail: `No history found for your search`});
      else {
        this.collapseHistory = false;
        this.collapseResults = this.collapseSearch = true;
      }
    });
  }

  setStatus(params: any) {
    if (params.data.status === 'Submitted' || params.data.status.includes('Processing TI')) {
      const eDiv = document.createElement('div');
      const self = this;
      eDiv.innerHTML = `${params.data.status}  <i class="pi pi-refresh" data-toggle="tooltip" data-placement="top" title="Refresh Status" style="font-size: 0.8rem; color: blue; cursor: pointer; margin-left: 20px;"></i>`;
      eDiv.addEventListener('click', () => {
        self.refreshStatus(params, false);
      });
      return eDiv;
    } else if (params.data.status === 'Coding Failed' || params.data.status.includes(' Coded')) {
      const eDiv = document.createElement('div');
      const self = this;
      eDiv.innerHTML = `${params.data.status}  <i class="pi pi-upload" data-toggle="tooltip" data-placement="top" title="Resubmit failed data" style="font-size: 0.8rem; color: blue; cursor: pointer; margin-left: 20px;"></i>`;
      eDiv.addEventListener('click', () => {
        self.resubmitData(params);
      });
      return eDiv;
    }
    return params.data.status;
  }

  refreshStatus(event: any, refreshAfterSubmit: boolean) {
    let params = new HttpParams();
    params = params.append('id', event.data.id);
    this.apiService.getData('GetCodeHistorySingle', params).subscribe((res: any) => {
      if (res) {
        const row = this.historyData.find((d: any) => d.id === event.data.id);
        if (!refreshAfterSubmit && res.status === row.status) {
          setTimeout(() => {
            this.customMessageService.showMessage({'severity': 'info', summary: "No Change", detail: `No change in Status`});
          }, 10);
        } else {
          if (refreshAfterSubmit) {
            row.tiCount = res.codeData.filter((cd: any) => cd.programCode).length;
            row.submitTI = null;
          }
          row.status = res.status;
          row.successExcelLink = res.successExcelLink;
          row.failedExcelLink = res.failedExcelLink;
          res.codeData.forEach((d: any) => {
            const rec = row.codedData.find((cd: any) => cd.geId == d.geId);
            rec.newCvn = d.newCvn;
            rec.isTISuccessful = d.isTISuccessful === true ? 'True' : d.isTISuccessful === false ? 'False' : '';
            rec.programCode = d.programCode;
            rec.requestType = d.requestType;
            rec.requester = d.requester;
            rec.parentRole = d.parentRole;
            rec.yearCoded = d.yearCoded;
            rec.comments = d.comments;
            rec.startingMaterials = d.startingMaterials;
            rec.error = d.error;
          });
          setTimeout(() => {
            this.histGridApi.applyTransaction({ update: [row] });
          }, 10);
        }
      } else 
        this.customMessageService.showMessage({'severity': 'warn', summary: "Not Found", detail: `Record not found`});
    });
  }

  resubmitData(event: any) {
    const failedData = event.data.codedData.filter((d: any) => d.error);
    const postData = this.createResubmitPostData(event.data, failedData);
    postData['existingGuid'] = event.data.id;
    let tiRequests = failedData.filter((row: any) => row.sentToTI === "True"); 
    if (tiRequests && tiRequests.length > 0) {
      let tiCodeTemplateDTOs: TICodeTemplateDTO [] = []; 
      tiRequests.forEach((d: any) => {
        tiCodeTemplateDTOs.push({ 
          cropGenusId : event.data.crop, 
          requestType : "TI", 
          requester : StaticFields.userInfo.onPremisesSamAccountName, 
          programCode : d.programCode, 
          comments : d.comments?.trim(),
          referenceId: d.geId,
          baseGEId: d.geId,
          parentRole: d.parentRole, 
          yearCoded: d.yearCoded, 
          startingMaterials: JSON.parse(d.startingMaterials)
        });
      });
      postData['tiCodeTemplateDTOs'] = tiCodeTemplateDTOs;
    }
    this.apiService.putData('ResubmitCodeData', postData, false, false).subscribe();
    this.customMessageService.showMessage({'severity': 'info', summary: 'Code Data Resubmitted', detail: `${postData.inbredCodingArgs.length} record(s) have been resubmitted for coding. You will get an email once process is complete.`});
    event.data.status = 'Submitted';
    event.data.actionOn = null;
    event.api.applyTransaction({ update: [event.data] });
  }
  createResubmitPostData(codeHistory: any, rowData: any[]): any {
    rowData.forEach((d: any) => d.error = "");
    let inbredCodingArgs: InbredCodingArg [] = [];   
    rowData.map((row: any) => inbredCodingArgs.push({ geId: row.geId, geName: row.submittedName, convBase: row.convBase?.trim(), blinPair: row.blinPair?.trim(), materialType: row.materialType, gender: row.gender, heteroticPrefix: row.hetrPrefix?.trim(), inventorLeids: row.inventorLeids?.length > 0 ? row.inventorLeids?.split(",").map(Number): [], projectCode: row.projectCode, suffix: row.suffix?.trim(), traitValues: () => {
      let traits: TraitValue[] = [];
      Object.keys(row).filter(k => k.includes('_trait_')).forEach((k : any) => {
        const trtParts = k.split('_trait_');
        traits.push({traitId: trtParts[0], value: row[k], traitName: trtParts[1]});
      });
      return traits;
    }}));
    inbredCodingArgs.forEach(ele => ele.traitValues =  ele.traitValues());
    let postData : any = {};
    postData['crop'] = codeHistory.crop;
    postData['codingType'] = codeHistory.codingType;
    postData['appUserId'] = StaticFields.appUserId; 
    postData['userName'] = StaticFields.userInfo.onPremisesSamAccountName;
    postData['inbredCodingArgs'] = inbredCodingArgs.filter(a => a.geId);
    return postData;
  }

  setDataCount(params: any) {
    return this.setCount(params, false, false);
  }

  setTIDataCount(params: any) {
    return this.setCount(params, true, false);
  }

  resubmitTI(params: any) {
    return this.setCount(params, true, true);
  }

  setCount(params: any, isTI: boolean, isResubmitTI: boolean) {
    const eDiv = document.createElement('div');
    const count = isTI ? params.data.tiCount : params.data.count;
    if (isResubmitTI) {
      if (!(params.data.status === 'Submitted' || params.data.status.includes('Processing TI')) && (params.data.count - params.data.tiCount) > 0) {
        const self = this;
        eDiv.innerHTML = `<a data-toggle="tooltip" data-placement="top" title="Send missed TI Data" style="color: blue; text-decoration: underline; cursor: pointer;">Send to TI</a>`;
        eDiv.addEventListener('click', () => {
          self.openTIModal(params.data);
        });
      }
    } else {
      if (count > 0) {
        const self = this;
        eDiv.innerHTML = `<a data-toggle="tooltip" data-placement="top" title="View Code Data" style="color: blue; text-decoration: underline; cursor: pointer;">${count}</a>`;
        eDiv.addEventListener('click', () => {
          self.openCodeDetails(params.data, isTI);
        });
      } else 
        eDiv.innerHTML = `${count}`;
    }
    return eDiv;
  }

  openTIModal(row: any) {
    this.showTIData = false;
    this.tiData.splice(0);
    this.tiColDefs.splice(0);
    this.selHistoryRow = row;
    this.tiColDefs.push(
      { field: 'geId', headerName : 'GeId', width : 165, headerTooltip : 'GeId' },
      { field: 'cvn', headerName : 'Ge Name', width : 165, headerTooltip : 'Ge Name' },
      { field: 'program', headerName : 'ProgramCode',  width : 165 },
      { field: 'yrcoded', headerName : 'YearCoded', width : 165 },
      { field: 'materialType', headerName : 'MaterialType', headerTooltip: 'Material Type',  width : 165 },
      { field: 'codingType', headerName: 'Coding Type' },
      { field: 'heteroticPrefix', headerName : 'HeteroticPrefix', headerTooltip: 'Heterotic Prefix',  width : 165 },
      { field: 'sendToTI', headerName : 'Send To TI', cellRenderer: 'agCheckboxCellRenderer', headerTooltip: 'Check to send SIID to TI', width : 165, 
        tooltipValueGetter: (p: any) => {
          if (this.tiColDefs.findIndex(col => col.field.includes('~')) > -1)
            return '';
          return 'Disabled, since no Starting Material found for selected project and year';
        },
        editable: (p: any) => {
          if (this.tiColDefs.findIndex(col => col.field.includes('~')) > -1)
            return true;
          return false;
        }
      },
      { field: 'comments', headerName : 'Comments', headerTooltip: 'comments',  width : 165, editable: (params : any) => params.data.sendToTI },
      { field: 'parentRole', headerName : 'ParentRole', headerTooltip: 'parentRole',  width : 165, editable: (params : any) => params.data.sendToTI, cellEditor: "agSelectCellEditor", cellEditorParams: { values: ["Male", "Female"] } as ISelectCellEditorParams,
        cellStyle: (params: any) => {  
          return params.data.sendToTI && (params.data.parentRole == undefined || params.data.parentRole == "") ? this.styleRequired : null;       
      }}
    );
    if (row.codedData.filter((cd: any) => cd.isTISuccessful === 'True').length > 0)
      this.showTIData = true;
    setTimeout(() => {
      row.codedData.filter((cd: any) => cd.isTISuccessful !== 'True' && cd.newCvn).forEach((d: any) => {
        this.tiData.push({
          crop: row.crop,
          geId: d.geId,
          cvn: d.newCvn,
          materialType: d.materialType,
          codingType: row.codingType,
          heteroticPrefix: d.hetrPrefix,
          sendToTI: false
        });
      });
      const existingTIData = row.codedData.filter((cd: any) => cd.isTISuccessful === 'True');
      if (existingTIData.length > 0) {
        this.tiYear = existingTIData[0].yearCoded;
        this.tiProgram = { code: existingTIData[0].programCode };
        this.getStartingMaterials();
      } else
        this.viewTIData = true;
    }, 1);
  }

  setTIPrograms() {
    let selectCountry = '';
    if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
      selectCountry = ',CountryName';
    this.apiService.getOData(`ProgramPreferences?$filter=CropName eq '${this.selHistoryCrop.Name}'and IsActive&$select=Id,Code,Description${selectCountry}`, false).subscribe((result : any) => {
      if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
        result.value = result.value.filter((r: any) => StaticFields.countriesToShow.includes(r.countryName.toUpperCase()));
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)); 
      this.tiPrograms = result.value.map((d: any) => { return {code: d.code, desc: d.description};});
    });
  }

  getStartingMaterials() {
    this.showTIData = true;
    this.viewTIData = false;
    let params = new HttpParams();
    params = params.append('crop', this.selHistoryCrop.Name);
    params = params.append('codingType', this.tiData[0].codingType);
    params = params.append('year', this.tiYear);
    params = params.append('program', this.tiProgram.code);
    this.tiData.forEach((d: any) => { 
      d.program = this.tiProgram.code;
      d.yrcoded = this.tiYear;
    });
    this.apiService.getData("GetCodingColumns", params, true).subscribe((res: any) => {
      if (res) {
        this.addTIMaterials(null, this.tiColDefs, res.startingMaterials);
      }
      this.tiGridApi.setGridOption("columnDefs", this.tiColDefs);
    });
  }

  openCodeDetails(row: any, isTI: boolean) {
    if (isTI) {
      this.selHistoryRow = row;
      const showErrorCol = row.codedData.filter((d: any) => d.sentToTI === "True" && d.isTISuccessful === "False").length > 0;
      this.codingData = row.codedData.filter((r: any) => r.programCode);
      const colsToAdd: string[] = [];
      this.codingData.forEach((cd: any) => {
        const materials: any[] = JSON.parse(cd.startingMaterials);
        if (materials && materials.length > 0) {
          materials.forEach(m => {
            const profCol = Object.keys(m).filter(c => c.toUpperCase() === "GENETICPROFILE")[0];
            const siIdCol = Object.keys(m).filter(c => c.toUpperCase() === "SIID")[0];
            cd[`${m[profCol].join()}_SIID`] = m[siIdCol];
            if (!colsToAdd.includes(`${m[profCol].join()}_SIID`))
              colsToAdd.push(`${m[profCol].join()}_SIID`);
          });
        }
      });
      this.setTIGridCols(showErrorCol, [...new Set(colsToAdd)]);
    } else {
      this.selHistoryRow = null;
      const showCodingCol = row.codedData.filter((d: any) => d.newCvn).length > 0;
      const showErrorCol = row.codedData.filter((d: any) => d.error).length > 0;
      const traits = row.codedData.length > 0 ? Object.keys(row.codedData[0]).filter(k => k.includes('_trait_')) : [];
      this.setCodeGridCols(this.selectedCrop?.Name === 'CORN', showErrorCol, showCodingCol, traits);
      this.codingData = row.codedData;
    }
    this.showCodingData = true;
  }

  setCodeGridCols(showTICol: boolean, showErrorCol: boolean, showCodingCol: boolean, traits: any[]) {
    this.codingColDefs = [
      { field: 'geId', headerName : 'GEID' },
      { field: 'submittedName', headerName : 'Submitted Name' },
      { field: 'inventorLeids', headerName : 'Inventor Leids' },
      { field: 'materialType', headerName : 'Material Type' },
      { field: 'projectCode', headerName : 'Project Code' }
    ];
    if (showCodingCol)
      this.codingColDefs.push({ field: 'newCvn', headerName : 'Coded Name' });
    if (showTICol) {
      this.codingColDefs.push({ field: 'sentToTI', headerName : 'Sent to TI' });
      this.codingColDefs.push({ field: 'isTISuccessful', headerName : 'TI Succeeded' });
    }
    if (showErrorCol)
      this.codingColDefs.push({ field: 'error', headerName : 'Error' });
    traits.forEach(t => this.codingColDefs.push({ field: t, headerName : t.split('_trait_')[1] }));
  }

  setTIGridCols(showErrorCol: boolean, colsToAdd: string[]) {
    this.codingColDefs = [
      { field: 'geId', headerName : 'Base GEID' },
      { field: 'requestType', headerName : 'Request Type' },
      { field: 'requester', headerName : 'Requester' },
      { field: 'parentRole', headerName : 'Parent Role' },
      { field: 'programCode', headerName : 'Program Code' },
      { field: 'yearCoded', headerName : 'Year Coded' },
      { field: 'comments', headerName : 'Comments' },
      { field: 'isTISuccessful', headerName : 'TI Succeeded' }
    ];
    colsToAdd.forEach(c => {
      this.codingColDefs.push({ field: c, headerName: c});
    });
    if (showErrorCol)
      this.codingColDefs.push({ field: 'error', headerName : 'Error' });
  }

  fillTIGrid(excelData: any[]) {
    const mappedCols: any = [];
    const geid = ['GEID', 'GE ID', 'GE_ID'];
    const geName = ['GENAME', 'GE NAME', 'GE_NAME'];
    const sendToTI = ['SENDTOTI', 'SEND TO TI', 'SEND_TO_TI'];
    let duplicateColFound = false;
    let dataKey: string;
    Object.keys(excelData[0]).forEach(k => {
      if (geid.findIndex(c => c === k.toUpperCase().trim().replace('*', '')) > -1 && excelData[0][k]) {
        if (mappedCols.findIndex((c: any) => c.mappedCol === 'geId') > -1)
          duplicateColFound = true;
        mappedCols.push({ header: k, mappedCol: 'geId'});
        dataKey = 'geId';
      } else if (geName.findIndex(c => c === k.toUpperCase().trim().replace('*', '')) > -1 && excelData[0][k]) {
        if (dataKey !== 'geId') {
          if (mappedCols.findIndex((c: any) => c.mappedCol === 'cvn') > -1)
            duplicateColFound = true;
          mappedCols.push({ header: k, mappedCol: 'cvn'});
          dataKey = 'cvn';
        }
      } else if (sendToTI.findIndex(c => c === k.toUpperCase().trim().replace('*', '')) > -1) {
        if (mappedCols.findIndex((c: any) => c.mappedCol === 'sendToTI') > -1)
          duplicateColFound = true;
        mappedCols.push({ header: k, mappedCol: 'sendToTI'});
      } else {
        let foundCol = this.tiColDefs.find(c => c.headerName.toUpperCase() === k.toUpperCase().trim().replace('*', ''));
        if (foundCol) {
          if (mappedCols.findIndex((c: any) => c.mappedCol === foundCol.field) > -1)
            duplicateColFound = true;
          mappedCols.push({ header: k, mappedCol: foundCol.field});
        }
      }
    });
    this.loader.clearMessage();
    if (duplicateColFound) {
      this.customMessageService.showMessage({'severity': 'error', summary: 'Duplicate Columns', detail: "Sheet contains duplicate columns."}); 
      return;
    }
    if (!dataKey) {
      this.customMessageService.showMessage({'severity': 'error', summary: 'Invalid File', detail: "Sheet doesn't contain GE Id or GE Name."}); 
      return;
    }
    const key = mappedCols.find((c: any) => c.mappedCol === dataKey).header;
    excelData.forEach(row => {
      const data = this.tiData.find((ti: any) => row[key] && ti[dataKey].toString().toUpperCase() === row[key].toString().toUpperCase());
      if (data) {
        data['sendToTI'] = data['parentRole'] = data['comments'] = null;
        const tiHeader = mappedCols.find((c: any) => c.mappedCol === 'sendToTI').header;
        const roleHeader = mappedCols.find((c: any) => c.mappedCol === 'parentRole').header;
        mappedCols.forEach((col: any) => {
          const isSendToTI = row[tiHeader] === true || row[tiHeader].toString().toUpperCase() === 'TRUE' ? true : false;
          if (row[col.header] && isSendToTI) {
            if (col.mappedCol === 'sendToTI') {
              data[col.mappedCol] = isSendToTI;
            } else if (col.mappedCol === 'parentRole') {
              data[col.mappedCol] = row[col.header].toUpperCase() === 'MALE' ? 'Male' : row[col.header].toUpperCase() === 'FEMALE' ? 'Female' : row[col.header].toUpperCase() === 'BOTH' ? 'Both' : row[col.header];
            } else if (col.mappedCol === 'comments') {
              data[col.mappedCol] = row[col.header];
            } else if (col.header.toUpperCase().endsWith('_SIID')) {
              data[col.mappedCol] = null;
              if ((row[roleHeader].toUpperCase() === 'MALE' && col.mappedCol.toUpperCase().endsWith('~MALE')) || (row[roleHeader].toUpperCase() === 'FEMALE' && col.mappedCol.toUpperCase().endsWith('~FEMALE')) || row[roleHeader].toUpperCase() === 'BOTH')
                data[col.mappedCol] = row[col.header];
            }
          }
        });
      }
    });
    this.tiGridApi.redrawRows();  
  }

  validateTIData() {
    let tiRequests = this.tiData.filter((row: any) => row.sendToTI == true); 
    const isTIValidated = tiRequests.length > 0 ? this.validateTIRequests(tiRequests) : false;
    if (isTIValidated)
      this.validateOrSubmitTIRequestsFromService('ValidateTIRequests', tiRequests, true, this.tiData, this.tiColDefs, this.tiGridApi);
  }

  submitTIData() {
    let tiRequests = this.tiData.filter((row: any) => row.sendToTI == true); 
    const isTIValidated = tiRequests.length > 0 ? this.validateTIRequests(tiRequests) : false;
    if (isTIValidated) {
      const tiPostData = this.getTIPostData(tiRequests, this.tiColDefs);
      tiPostData['id'] = this.selHistoryRow.id;
      
      this.apiService.putData('SubmitTIRequests', tiPostData, false, true).subscribe((res: any) => {
        if (res.msgType === 'success') {
          this.selHistoryRow.status = this.selHistoryRow.status.replace(", TI Failed",  "");
          tiRequests.forEach((d: any) => {
            d.isTISuccessful = this.selHistoryRow.codedData.find((r: any) => r.geId === d.geId).isTISuccessful = "True";
          });
          this.customMessageService.showMessage({'severity': 'info', summary: "TI Submitted", detail: `TI Submission successful.`});
          const dummyEvent = { data: { id: this.selHistoryRow.id } };
          this.refreshStatus(dummyEvent, true);
          this.showTIData = false;
        } else if (res.data && Object.keys(res.data).length > 0) {
          if (this.tiColDefs.findIndex(c => c.field === 'error') === -1)
            this.tiColDefs.push({ field: 'error', headerName : 'Error' });
          Object.keys(res.data).forEach(geId => {
            this.selHistoryRow.codedData.find((r: any) => r.geId === Number(geId)).error = res.data[geId];
            tiRequests.find((r: any) => r.geId === Number(geId)).error = res.data[geId];
          });
          this.customMessageService.showMessage({'severity': 'warn', summary: "TI Submission Error", detail: `TI Submission failed for few rows. Please check error column for details.`});
          const tiData = this.tiData.splice(0);
          setTimeout(() => {
            this.tiData = tiData;
          }, 10);
        }
      });
    }
  }

  getModalHeader() {
    return this.codingColDefs.find(col => col.field === 'programCode') ? 'TI Data': 'Coding Data';
  }

  resubmitTIData() {
    const failedData = this.codingData.filter((d: any) => d.isTISuccessful === "False");
    const tiData = JSON.parse(JSON.stringify(failedData));
    tiData.crop = this.selHistoryRow.crop;
    tiData.forEach((d: any) => {
      const startingMaterials: TICodeTemplateStartingMaterial[] = [];
      Object.keys(d).filter(col => col.endsWith("_SIID")).forEach(col => {
        startingMaterials.push({sIId: d[col], geneticProfile: (col.split('_')[0]).toUpperCase().split(',')})
      })
      d.startingMaterials = startingMaterials;
    });
    const tiPostData = this.getTIPostData(tiData, this.columnDefs, true);
    tiPostData['id'] = this.selHistoryRow.id;
    
    this.apiService.putData('SubmitTIRequests', tiPostData, false, true).subscribe((res: any) => {
      if (res.msgType === 'success') {
        this.selHistoryRow.status = this.selHistoryRow.status.replace(", TI Failed",  "");
        failedData.forEach((d: any) => {
          d.isTISuccessful = this.selHistoryRow.codedData.find((r: any) => r.geId === d.geId).isTISuccessful = "True";
        });
      } 
      if (res.data && Object.keys(res.data).length > 0) {
        if (this.codingColDefs.findIndex(c => c.field === 'error') === -1)
          this.codingColDefs.push({ field: 'error', headerName : 'Error' });
        Object.keys(res.data).forEach(geId => {
          this.selHistoryRow.codedData.find((r: any) => r.geId === Number(geId)).error = res.data[geId];
          failedData.find((r: any) => r.geId === Number(geId)).error = res.data[geId];
        });
        this.customMessageService.showMessage({'severity': 'warn', summary: "TI Submission Error", detail: `TI Submission failed. Please check error column for details.`});
      }
      const codeData = this.codingData.splice(0);
      setTimeout(() => {
        this.codingData = codeData;
      }, 10);
    });
  }
}